var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _g, _g2, _g3, _path145, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAward(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1000,
    height: 550,
    viewBox: "0 0 1000 550",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2109_83633)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M434.107 272.532C432.69 270.132 431.69 267.672 431.123 265.182C430.556 262.692 430.272 260.231 430.272 257.831C430.272 255.43 430.556 253.015 431.123 250.525C431.69 248.049 432.69 245.604 434.107 243.219H438.867C438.166 244.396 437.554 245.619 437.047 246.872C436.539 248.124 436.107 249.377 435.778 250.629C435.45 251.881 435.211 253.104 435.062 254.327C434.913 255.535 434.838 256.712 434.838 257.816C434.838 258.919 434.913 260.097 435.062 261.32C435.211 262.542 435.45 263.78 435.778 265.047C436.107 266.3 436.525 267.567 437.047 268.82C437.554 270.072 438.166 271.31 438.867 272.517H434.107V272.532Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M461.428 266.27C461.428 266.822 461.324 267.314 461.115 267.776C460.906 268.238 460.638 268.641 460.294 268.969C459.951 269.312 459.548 269.58 459.101 269.774C458.638 269.968 458.146 270.072 457.623 270.072H445.149C444.627 270.072 444.135 269.968 443.672 269.774C443.209 269.58 442.807 269.312 442.478 268.969C442.15 268.626 441.866 268.223 441.658 267.776C441.449 267.314 441.344 266.807 441.344 266.27V248.035C441.344 247.483 441.449 246.991 441.658 246.529C441.866 246.066 442.135 245.664 442.478 245.336C442.821 244.993 443.224 244.724 443.672 244.531C444.135 244.337 444.627 244.232 445.149 244.232H457.295C457.817 244.232 458.31 244.337 458.772 244.531C459.235 244.724 459.638 244.993 459.966 245.336C460.309 245.679 460.578 246.081 460.787 246.529C460.996 246.991 461.1 247.498 461.1 248.035V251.315H456.564V248.884C456.564 248.706 456.504 248.571 456.4 248.452C456.295 248.348 456.146 248.288 455.967 248.288H446.447C446.268 248.288 446.134 248.348 446.015 248.452C445.91 248.556 445.85 248.706 445.85 248.884V254.401H457.609C458.131 254.401 458.623 254.506 459.086 254.7C459.548 254.893 459.951 255.162 460.279 255.505C460.623 255.848 460.891 256.25 461.1 256.698C461.309 257.16 461.413 257.667 461.413 258.203V266.27H461.428ZM456.31 266.002C456.489 266.002 456.624 265.942 456.743 265.838C456.848 265.733 456.907 265.584 456.907 265.405V259.038C456.907 258.86 456.848 258.725 456.743 258.606C456.639 258.502 456.489 258.442 456.31 258.442H445.865V265.405C445.865 265.584 445.925 265.718 446.03 265.838C446.134 265.942 446.283 266.002 446.462 266.002H456.31Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M484.079 258.651H465.532V243.696H481.975V247.498H470.053V249.302H481.677V253.044H470.053V254.849H484.079V258.651ZM490.615 271.846H467.964V260.589H490.615V271.846ZM486.093 267.97V264.466H472.5V267.97H486.093ZM490.615 259.471H486.078V243.129H490.615V259.471Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M519.413 259.873C518.756 259.352 518.144 258.845 517.577 258.382C517.01 257.92 516.443 257.443 515.906 256.951C515.354 256.474 514.817 255.982 514.265 255.49C513.713 254.998 513.146 254.461 512.519 253.894C511.266 255.057 510.057 256.146 508.893 257.19C507.714 258.233 506.476 259.292 505.163 260.395L502.432 257.279C503.7 256.161 504.849 255.132 505.894 254.178C506.938 253.223 507.983 252.254 509.057 251.24C509.43 250.912 509.714 250.495 509.908 250.003C510.102 249.511 510.206 249.019 510.206 248.512V243.725H514.802V248.512C514.802 249.019 514.906 249.511 515.1 250.003C515.294 250.495 515.578 250.897 515.951 251.24C516.473 251.717 516.966 252.18 517.413 252.597C517.861 253.03 518.323 253.462 518.771 253.894C519.234 254.327 519.711 254.774 520.233 255.236C520.741 255.698 521.337 256.205 521.994 256.742L519.398 259.859L519.413 259.873ZM529.723 271.846H506.371V261.603H510.907V267.836H529.723V271.832V271.846ZM529.037 263.869H524.501V251.986H519.055V247.975H524.501V243.114H529.037V263.855V263.869Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M549.628 257.011H533.334V243.561H537.87V246.38H545.092V243.561H549.628V257.011ZM558.745 272.174H535.96V263.869H553.553V262.498H535.916V258.83H558.074V267.135H540.482V268.507H558.73V272.174H558.745ZM545.092 253.208V250.122H537.87V253.208H545.092ZM558.104 257.861H553.568V243.129H558.104V248.348H561.774V252.508H558.104V257.861Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M562.625 272.532C563.326 271.325 563.923 270.102 564.445 268.835C564.953 267.582 565.385 266.315 565.714 265.062C566.042 263.81 566.281 262.557 566.43 261.335C566.579 260.112 566.654 258.934 566.654 257.831C566.654 256.727 566.579 255.549 566.43 254.342C566.281 253.134 566.042 251.896 565.714 250.644C565.385 249.391 564.968 248.139 564.445 246.886C563.923 245.634 563.326 244.411 562.625 243.233H567.385C568.802 245.619 569.802 248.049 570.369 250.539C570.936 253.03 571.22 255.46 571.22 257.846C571.22 260.231 570.936 262.706 570.369 265.196C569.802 267.686 568.802 270.147 567.385 272.547H562.625V272.532Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M452.296 209.476H391.895V185.277C391.895 181.355 392.999 178.179 395.207 175.764C397.416 173.348 400.43 171.813 404.235 171.142L435.077 165.699V153.011H410.949V162.986H392.805V149.939C392.805 146.018 394.028 142.827 396.476 140.381C398.923 137.936 402.116 136.714 406.04 136.714H439.956C443.881 136.714 447.074 137.936 449.521 140.381C451.968 142.827 453.192 146.018 453.192 149.939V166.519C453.192 170.441 452.102 173.617 449.924 176.032C447.745 178.448 444.716 179.983 440.852 180.654L410.009 186.097V193.164H452.281V209.476H452.296Z",
    fill: "#BBA4CE"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M472.873 222.255H459.265L462.891 193.343H480.945L472.873 222.255Z",
    fill: "#BBA4CE"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M513.787 209.476H494.748V153.011H486.049V136.699H513.802V209.476H513.787Z",
    fill: "#BBA4CE"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M586.156 196.236C586.156 200.157 584.933 203.348 582.485 205.793C580.038 208.239 576.845 209.461 572.921 209.461H538.094C534.17 209.461 530.977 208.239 528.53 205.793C526.083 203.348 524.859 200.157 524.859 196.236V149.924C524.859 146.003 526.083 142.812 528.53 140.367C530.977 137.921 534.17 136.699 538.094 136.699H572.921C576.845 136.699 580.038 137.921 582.485 140.367C584.933 142.812 586.156 146.003 586.156 149.924V196.236ZM568.012 193.149V152.996H542.974V193.149H568.012Z",
    fill: "#BBA4CE"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M656.898 196.236C656.898 200.157 655.675 203.348 653.228 205.793C650.781 208.239 647.587 209.461 643.663 209.461H608.837C604.912 209.461 601.719 208.239 599.272 205.793C596.825 203.348 595.601 200.157 595.601 196.236V149.924C595.601 146.003 596.825 142.812 599.272 140.367C601.719 137.921 604.912 136.699 608.837 136.699H643.663C647.587 136.699 650.781 137.921 653.228 140.367C655.675 142.812 656.898 146.003 656.898 149.924V196.236ZM638.769 193.149V152.996H613.731V193.149H638.769Z",
    fill: "#BBA4CE"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M713.853 178.567H666.06V134.611H713.853V178.567ZM740.07 213.726H671.044V183.905H688.815V198.86H740.055V213.726H740.07ZM696.082 163.612V149.566H683.831V163.612H696.082ZM738.712 191.077H720.941V133.702H738.712V149.656H747.605V164.879H738.712V191.077Z",
    fill: "#BBA4CE"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M828.046 195.878H810.275V193.075H790.235V181.743H810.275V172.498L804.112 178.656H785.789V190.525H767.555V178.656H750.41V166.415H810.275V133.702H828.046V195.878ZM771.181 163.343C765.197 163.343 760.497 162.002 757.08 159.318C753.663 156.634 751.962 152.861 751.962 148.031C751.962 143.2 753.663 139.353 757.08 136.654C760.497 133.97 765.197 132.628 771.181 132.628H786.968C792.951 132.628 797.651 133.97 801.068 136.654C804.485 139.338 806.186 143.14 806.186 148.031C806.186 152.921 804.47 156.634 801.068 159.318C797.651 162.002 792.951 163.343 786.968 163.343H771.181ZM828.404 213.726H757.304V192.613H775.075V201.037H828.404V213.726ZM783.79 151.102C785.177 151.102 786.296 150.849 787.147 150.327C787.997 149.82 788.415 149.015 788.415 147.926C788.415 146.838 787.997 146.047 787.147 145.57C786.296 145.093 785.177 144.84 783.79 144.84H774.359C772.972 144.84 771.852 145.078 771.002 145.57C770.151 146.047 769.734 146.838 769.734 147.926C769.734 149.015 770.151 149.82 771.002 150.327C771.852 150.834 772.972 151.102 774.359 151.102H783.79Z",
    fill: "#BBA4CE"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M231.147 186.753H169.91V177.314H192.754V172.662H208.302V177.314H231.147V186.753ZM228.028 175.436C223.254 174.511 218.628 173.602 214.137 172.692C209.645 171.798 205.109 170.739 200.528 169.531C195.903 170.739 191.337 171.783 186.86 172.692C182.369 173.587 177.743 174.511 172.969 175.436L170.119 166.415C173.685 165.669 177.176 164.924 180.608 164.164C184.025 163.403 187.487 162.508 190.949 161.495C191.74 161.271 192.292 160.988 192.62 160.66H172.909V151.296H192.56V147.27H208.526V151.296H228.237V160.66H208.377C208.616 160.988 209.183 161.256 210.108 161.495C213.584 162.508 217.016 163.403 220.418 164.164C223.821 164.924 227.327 165.684 230.938 166.415L228.028 175.436ZM215.808 189.034C218.21 189.034 220.284 189.317 222.015 189.899C223.746 190.48 225.178 191.271 226.312 192.285C227.446 193.298 228.297 194.491 228.849 195.863C229.401 197.235 229.685 198.666 229.685 200.202C229.685 201.738 229.401 203.154 228.819 204.496C228.237 205.838 227.372 207.016 226.208 208.03C225.044 209.044 223.597 209.849 221.836 210.43C220.075 211.012 217.986 211.295 215.584 211.295H185.115C182.712 211.295 180.653 211.012 178.937 210.43C177.221 209.849 175.819 209.059 174.699 208.03C173.595 207.016 172.775 205.838 172.237 204.496C171.7 203.154 171.432 201.723 171.432 200.202C171.432 198.681 171.715 197.235 172.267 195.863C172.819 194.506 173.67 193.313 174.804 192.285C175.938 191.271 177.37 190.465 179.101 189.899C180.832 189.317 182.906 189.034 185.309 189.034H215.778H215.808ZM212.749 201.738C213.808 201.738 214.659 201.618 215.286 201.395C215.912 201.156 216.226 200.769 216.226 200.217C216.226 199.158 215.062 198.621 212.749 198.621H188.457C186.144 198.621 184.98 199.158 184.98 200.217C184.98 200.769 185.294 201.171 185.92 201.395C186.547 201.618 187.383 201.738 188.457 201.738H212.749Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M269.539 181.683C267.137 180.058 264.765 178.403 262.422 176.688C260.079 174.974 257.826 173.05 255.648 170.933C253.424 172.976 251.126 174.869 248.739 176.614C246.352 178.373 243.8 180.147 241.069 181.952L233.295 172.722C235.892 170.784 238.309 168.905 240.547 167.101C242.785 165.297 244.889 163.358 246.829 161.271C247.471 160.63 247.888 160.003 248.082 159.392C248.262 158.796 248.366 158.005 248.366 157.036V148.925H262.944V156.977C262.944 157.856 263.034 158.617 263.228 159.273C263.407 159.914 263.81 160.57 264.406 161.211C266.301 163.254 268.316 165.177 270.45 166.996C272.583 168.83 274.851 170.709 277.254 172.648L269.554 181.668L269.539 181.683ZM280.924 183.562C283.327 183.562 285.416 183.935 287.176 184.665C288.937 185.411 290.385 186.41 291.519 187.677C292.653 188.945 293.503 190.436 294.055 192.12C294.607 193.805 294.891 195.58 294.891 197.429C294.891 199.277 294.607 201.052 294.025 202.737C293.443 204.422 292.578 205.898 291.414 207.18C290.25 208.447 288.788 209.461 287.012 210.192C285.237 210.937 283.133 211.295 280.73 211.295H252.126C249.724 211.295 247.65 210.923 245.919 210.192C244.188 209.446 242.756 208.447 241.651 207.18C240.547 205.913 239.727 204.422 239.189 202.737C238.652 201.052 238.384 199.277 238.384 197.429C238.384 195.58 238.667 193.805 239.219 192.12C239.771 190.436 240.622 188.959 241.756 187.677C242.89 186.41 244.337 185.396 246.098 184.665C247.859 183.92 249.933 183.562 252.35 183.562H280.954H280.924ZM277.806 199.993C278.865 199.993 279.716 199.755 280.342 199.292C280.969 198.83 281.283 198.204 281.283 197.414C281.283 196.623 280.984 195.997 280.387 195.505C279.79 195.013 278.925 194.775 277.821 194.775H255.469C254.364 194.775 253.499 195.013 252.902 195.505C252.305 195.997 252.007 196.623 252.007 197.414C252.007 198.204 252.32 198.83 252.947 199.292C253.574 199.755 254.409 199.993 255.483 199.993H277.836H277.806ZM292.518 181.952H278.91V148.925H292.518V158.498H299.322V170.157H292.518V181.952Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M363.052 181.758H301.814V171.216H346.25V159.705H305.008V149.164H359.859V171.231H363.052V181.773V181.758ZM359.859 210.192H346.25V203.81L339.864 210.192H305.008V185.217H359.859V210.192ZM346.25 199.65V195.759H318.616V199.65H346.25Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.74,
    d: "M452.296 209.476H391.895V185.277C391.895 181.355 392.999 178.179 395.207 175.764C397.416 173.348 400.43 171.813 404.235 171.142L435.077 165.699V153.011H410.949V162.986H392.805V149.939C392.805 146.018 394.028 142.827 396.476 140.381C398.923 137.936 402.116 136.714 406.04 136.714H439.956C443.881 136.714 447.074 137.936 449.521 140.381C451.968 142.827 453.192 146.018 453.192 149.939V166.519C453.192 170.441 452.102 173.617 449.924 176.032C447.745 178.448 444.716 179.983 440.852 180.654L410.009 186.097V193.164H452.267V209.476H452.296ZM472.888 222.254H459.28L462.906 193.343H480.96L472.888 222.254ZM513.787 209.476H494.748V153.011H486.034V136.699H513.787V209.476ZM586.156 196.236C586.156 200.157 584.932 203.348 582.485 205.793C580.038 208.239 576.845 209.461 572.921 209.461H538.094C534.17 209.461 530.977 208.239 528.53 205.793C526.083 203.348 524.859 200.157 524.859 196.236V149.924C524.859 146.003 526.083 142.812 528.53 140.367C530.977 137.921 534.17 136.699 538.094 136.699H572.921C576.845 136.699 580.038 137.921 582.485 140.367C584.932 142.812 586.156 146.003 586.156 149.924V196.236ZM568.027 193.149V152.996H542.988V193.149H568.027ZM656.898 196.236C656.898 200.157 655.675 203.348 653.228 205.793C650.78 208.239 647.587 209.461 643.663 209.461H608.836C604.912 209.461 601.719 208.239 599.272 205.793C596.825 203.348 595.601 200.157 595.601 196.236V149.924C595.601 146.003 596.825 142.812 599.272 140.367C601.719 137.921 604.912 136.699 608.836 136.699H643.663C647.587 136.699 650.78 137.921 653.228 140.367C655.675 142.812 656.898 146.003 656.898 149.924V196.236ZM638.769 193.149V152.996H613.731V193.149H638.769ZM713.868 178.567H666.075V134.611H713.868V178.567ZM740.07 213.726H671.044V183.905H688.815V198.86H740.055V213.726H740.07ZM696.082 163.612V149.566H683.831V163.612H696.082ZM738.712 191.077H720.941V133.702H738.712V149.656H747.605V164.879H738.712V191.077ZM828.046 195.878H810.275V193.075H790.235V181.743H810.275V172.498L804.112 178.656H785.789V190.525H767.555V178.656H750.41V166.415H810.275V133.702H828.046V195.878ZM771.181 163.343C765.197 163.343 760.497 162.002 757.08 159.318C753.663 156.634 751.962 152.876 751.962 148.031C751.962 143.185 753.663 139.353 757.08 136.654C760.497 133.97 765.197 132.628 771.181 132.628H786.968C792.951 132.628 797.651 133.97 801.068 136.654C804.485 139.338 806.186 143.14 806.186 148.031C806.186 152.921 804.47 156.634 801.068 159.318C797.651 162.002 792.951 163.343 786.968 163.343H771.181ZM828.419 213.726H757.319V192.613H775.09V201.037H828.419V213.726ZM783.79 151.102C785.177 151.102 786.296 150.849 787.147 150.327C787.997 149.82 788.415 149.015 788.415 147.926C788.415 146.838 787.997 146.047 787.147 145.57C786.296 145.093 785.177 144.84 783.79 144.84H774.359C772.972 144.84 771.852 145.078 771.002 145.57C770.151 146.047 769.734 146.838 769.734 147.926C769.734 149.015 770.151 149.82 771.002 150.327C771.852 150.834 772.972 151.102 774.359 151.102H783.79Z",
    fill: "url(#paint0_linear_2109_83633)",
    style: {
      mixBlendMode: "overlay"
    }
  }), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M327.748 1.50598V88.8511",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M288.743 40.0345H20.7706C10.1167 40.0345 1.49219 31.4162 1.49219 20.7702C1.49219 10.1391 10.1167 1.50598 20.7706 1.50598H288.743C299.397 1.50598 308.022 10.1242 308.022 20.7702C308.022 31.4162 299.397 40.0345 288.743 40.0345Z",
    stroke: "url(#paint1_linear_2109_83633)",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M126.652 24.4083H104.226V21.3666H113.641V19.5177H106.344V9.11023H109.896V11.3468H120.982V9.11023H124.534V19.5177H117.237V21.3666H126.652V24.4083ZM125.16 31.8188H106.479V25.452H110.03V28.6727H125.16V31.8188ZM120.982 16.476V14.4482H109.896V16.476H120.982Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M141.484 22.4253C140.962 22.0078 140.485 21.6201 140.037 21.2473C139.589 20.8746 139.157 20.5018 138.724 20.1291C138.291 19.7563 137.859 19.3686 137.441 18.981C137.008 18.5933 136.56 18.1758 136.068 17.7285C135.083 18.638 134.143 19.5028 133.218 20.3229C132.293 21.143 131.323 21.978 130.293 22.8278L128.16 20.3825C129.159 19.5028 130.07 18.6977 130.875 17.9521C131.696 17.2066 132.517 16.4313 133.367 15.641C133.666 15.3876 133.889 15.0595 134.039 14.6719C134.188 14.2842 134.277 13.8965 134.277 13.4939V9.73652H137.888V13.4939C137.888 13.8965 137.963 14.2842 138.127 14.6719C138.276 15.0595 138.5 15.3726 138.799 15.641C139.216 16.0138 139.589 16.3716 139.948 16.7146C140.306 17.0426 140.664 17.3856 141.022 17.7285C141.38 18.0714 141.768 18.4293 142.171 18.7871C142.574 19.145 143.036 19.5476 143.544 19.9651L141.514 22.4104L141.484 22.4253ZM149.572 31.8188H131.248V23.7821H134.8V28.6727H149.572V31.8188ZM149.035 25.5565H145.483V16.2375H141.201V13.0914H145.483V9.27429H149.035V25.5565Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M172.282 14.5078C172.282 15.0595 172.237 15.5217 172.163 15.9094C172.088 16.2971 171.954 16.6251 171.775 16.9084C171.596 17.1917 171.342 17.4302 171.044 17.639C170.73 17.8477 170.342 18.0565 169.88 18.2503C168.388 18.8915 166.836 19.5177 165.224 20.129C163.613 20.7404 162.001 21.3517 160.39 21.963L159.151 19.2344C160.733 18.6231 162.21 18.0267 163.568 17.4452C164.941 16.8637 166.284 16.2971 167.597 15.7006C167.985 15.5366 168.268 15.313 168.447 15.0297C168.626 14.7613 168.701 14.3885 168.701 13.9412V12.9422H160.241V9.85576H172.252V14.4929L172.282 14.5078ZM166.463 31.9828C165.717 31.9828 165.045 31.8635 164.419 31.6548C163.792 31.4311 163.255 31.1031 162.792 30.6856C162.33 30.2681 161.986 29.7611 161.718 29.1498C161.464 28.5534 161.33 27.8675 161.33 27.122C161.33 26.3765 161.464 25.6906 161.718 25.0942C161.971 24.4978 162.33 23.9759 162.792 23.5584C163.24 23.1409 163.792 22.8129 164.419 22.5892C165.045 22.3656 165.732 22.2612 166.463 22.2612H175.177C175.923 22.2612 176.594 22.3656 177.221 22.5892C177.848 22.8129 178.385 23.1409 178.848 23.5584C179.31 23.9759 179.653 24.4829 179.922 25.0942C180.19 25.7055 180.31 26.3765 180.31 27.122C180.31 27.8675 180.176 28.5534 179.922 29.1498C179.668 29.7462 179.31 30.2681 178.848 30.6856C178.385 31.1031 177.848 31.4311 177.221 31.6548C176.594 31.8784 175.908 31.9828 175.177 31.9828H166.463ZM174.789 28.8814C175.401 28.8814 175.893 28.7323 176.236 28.4192C176.58 28.1061 176.759 27.6737 176.759 27.1071C176.759 26.5405 176.58 26.1081 176.236 25.795C175.893 25.4819 175.416 25.3328 174.789 25.3328H166.851C166.239 25.3328 165.747 25.4819 165.403 25.795C165.06 26.1081 164.881 26.5405 164.881 27.1071C164.881 27.6737 165.06 28.1061 165.403 28.4192C165.747 28.7323 166.224 28.8814 166.851 28.8814H174.789ZM179.713 21.6797H176.162V19.8756H172.521V16.7145H176.162V14.5973H173.073V11.4363H176.162V9.30408H179.713V21.6946V21.6797Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M203.676 25.8248H200.125V20.3825H195.484C194.888 20.9939 194.142 21.4859 193.276 21.8437C192.411 22.2016 191.426 22.3805 190.352 22.3805C189.277 22.3805 188.322 22.2016 187.472 21.8587C186.621 21.5008 185.89 21.0386 185.293 20.4422C184.696 19.8457 184.234 19.1599 183.905 18.3696C183.577 17.5794 183.413 16.7444 183.413 15.8498C183.413 14.9551 183.577 14.1202 183.905 13.3299C184.234 12.5397 184.696 11.8538 185.293 11.2574C185.89 10.6609 186.621 10.1987 187.472 9.84087C188.322 9.48302 189.277 9.31901 190.352 9.31901C191.426 9.31901 192.411 9.49793 193.276 9.85578C194.142 10.2136 194.873 10.7057 195.484 11.317H200.125V9.28918H203.676V25.8248ZM204.228 31.8188H185.905V24.0356H189.456V28.6727H204.228V31.8188ZM190.352 19.309C191.396 19.309 192.232 18.9809 192.828 18.3398C193.425 17.6987 193.724 16.8637 193.724 15.8498C193.724 14.8359 193.425 14.0158 192.828 13.3597C192.232 12.7186 191.396 12.3905 190.352 12.3905C189.307 12.3905 188.471 12.7186 187.875 13.3597C187.278 14.0009 186.979 14.8359 186.979 15.8498C186.979 16.8637 187.278 17.6987 187.875 18.3398C188.471 18.9809 189.307 19.309 190.352 19.309ZM200.125 17.2215V14.4929H197.141C197.245 14.9402 197.29 15.3875 197.29 15.8647C197.29 16.3418 197.245 16.804 197.141 17.2364H200.125V17.2215Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M47.9872 82.4248H24.0981V71.3464C24.0981 70.0343 24.4264 69.0054 25.0979 68.2599C25.7693 67.5144 26.6945 67.0224 27.8733 66.7838L41.6755 63.9508C41.8844 63.9061 42.0635 63.8017 42.1828 63.6824C42.3171 63.5482 42.3768 63.3842 42.3768 63.1755V56.9877C42.3768 56.7789 42.3171 56.6 42.1828 56.4807C42.0485 56.3465 41.8844 56.2869 41.6755 56.2869H30.6337C30.4248 56.2869 30.2457 56.3465 30.1264 56.4807C30.007 56.6149 29.9324 56.7789 29.9324 56.9877V62.2659H24.4861V55.9588C24.4861 55.3028 24.6055 54.6915 24.8591 54.1398C25.1128 53.5881 25.4411 53.111 25.8439 52.7084C26.2468 52.3058 26.7243 51.9778 27.2764 51.7392C27.8285 51.5006 28.4253 51.3813 29.052 51.3813H43.2423C43.869 51.3813 44.4658 51.5006 45.0179 51.7392C45.57 51.9778 46.0475 52.2909 46.4503 52.7084C46.8532 53.111 47.1815 53.5881 47.4352 54.1398C47.6888 54.6915 47.8082 55.3028 47.8082 55.9588V63.9508C47.8082 65.2629 47.4799 66.2917 46.8085 67.0373C46.137 67.7828 45.2119 68.2748 44.0331 68.5134L30.2308 71.3166C30.0219 71.3762 29.8429 71.4508 29.7235 71.5551C29.5892 71.6595 29.5295 71.8235 29.5295 72.0323V77.5491H47.9872V82.4397V82.4248Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M76.7704 77.8622C76.7704 78.5183 76.651 79.1296 76.3973 79.6813C76.1437 80.233 75.8154 80.7101 75.4125 81.1127C75.0097 81.5153 74.5322 81.8433 73.9801 82.0819C73.428 82.3204 72.8311 82.4397 72.2044 82.4397H57.6114C56.9847 82.4397 56.3878 82.3204 55.8357 82.0819C55.2836 81.8433 54.8061 81.5302 54.4033 81.1127C54.0004 80.7101 53.6721 80.233 53.4184 79.6813C53.1648 79.1296 53.0454 78.5332 53.0454 77.8622V55.9588C53.0454 55.3028 53.1648 54.6915 53.4184 54.1398C53.6721 53.5881 54.0004 53.111 54.4033 52.7084C54.8061 52.3058 55.2836 51.9778 55.8357 51.7392C56.3878 51.5006 56.9847 51.3813 57.6114 51.3813H72.2044C72.8311 51.3813 73.428 51.5006 73.9801 51.7392C74.5322 51.9778 75.0097 52.2909 75.4125 52.7084C75.8154 53.111 76.1437 53.5881 76.3973 54.1398C76.651 54.6915 76.7704 55.3028 76.7704 55.9588V77.8622ZM70.6079 77.5491C70.8168 77.5491 70.9958 77.4895 71.1152 77.3553C71.2346 77.2211 71.3092 77.0571 71.3092 76.8483V56.9877C71.3092 56.7789 71.2495 56.6 71.1152 56.4807C70.9809 56.3465 70.8168 56.2869 70.6079 56.2869H59.1781C58.9692 56.2869 58.7901 56.3465 58.6708 56.4807C58.5514 56.6149 58.4768 56.7789 58.4768 56.9877V76.8483C58.4768 77.0571 58.5365 77.236 58.6708 77.3553C58.8051 77.4895 58.9692 77.5491 59.1781 77.5491H70.6079Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M105.703 82.4248H81.814V71.3464C81.814 70.0343 82.1422 69.0054 82.8137 68.2599C83.4852 67.5144 84.4103 67.0224 85.5891 66.7838L99.3913 63.9508C99.6002 63.9061 99.7793 63.8017 99.8987 63.6824C100.033 63.5482 100.093 63.3842 100.093 63.1755V56.9877C100.093 56.7789 100.033 56.6 99.8987 56.4807C99.7644 56.3465 99.6002 56.2869 99.3913 56.2869H88.3495C88.1406 56.2869 87.9616 56.3465 87.8422 56.4807C87.7228 56.6149 87.6482 56.7789 87.6482 56.9877V62.2659H82.2019V55.9588C82.2019 55.3028 82.3213 54.6915 82.575 54.1398C82.8286 53.5881 83.1569 53.111 83.5598 52.7084C83.9626 52.3058 84.4401 51.9778 84.9922 51.7392C85.5443 51.5006 86.1412 51.3813 86.7679 51.3813H100.958C101.585 51.3813 102.182 51.5006 102.734 51.7392C103.286 51.9778 103.763 52.2909 104.166 52.7084C104.569 53.111 104.897 53.5881 105.151 54.1398C105.405 54.6915 105.524 55.3028 105.524 55.9588V63.9508C105.524 65.2629 105.196 66.2917 104.524 67.0373C103.853 67.7828 102.928 68.2748 101.749 68.5134L87.9466 71.3166C87.7377 71.3762 87.5587 71.4508 87.4393 71.5551C87.305 71.6595 87.2453 71.8235 87.2453 72.0323V77.5491H105.703V82.4397V82.4248Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M134.889 77.8622C134.889 78.5183 134.77 79.1296 134.516 79.6813C134.263 80.233 133.934 80.7101 133.531 81.1127C133.129 81.5153 132.651 81.8433 132.099 82.0819C131.547 82.3204 130.95 82.4397 130.323 82.4397H115.342C114.716 82.4397 114.119 82.3204 113.567 82.0819C113.015 81.8433 112.537 81.5302 112.134 81.1127C111.731 80.6952 111.403 80.233 111.149 79.6813C110.896 79.1296 110.776 78.5332 110.776 77.8622V55.9588C110.776 55.3028 110.896 54.6915 111.149 54.1398C111.403 53.5881 111.731 53.111 112.134 52.7084C112.537 52.3058 113.015 51.9778 113.567 51.7392C114.119 51.5006 114.716 51.3813 115.342 51.3813H129.935C130.562 51.3813 131.159 51.5006 131.711 51.7392C132.263 51.9778 132.741 52.2909 133.144 52.7084C133.546 53.111 133.875 53.5881 134.128 54.1398C134.382 54.6915 134.501 55.3028 134.501 55.9588V59.8952H129.055V56.9727C129.055 56.764 128.995 56.5851 128.861 56.4658C128.727 56.3316 128.563 56.272 128.354 56.272H116.924C116.715 56.272 116.536 56.3316 116.417 56.4658C116.282 56.6 116.223 56.764 116.223 56.9727V63.593H130.338C130.965 63.593 131.562 63.7123 132.114 63.9508C132.666 64.1894 133.143 64.5025 133.546 64.92C133.949 65.3226 134.278 65.7997 134.531 66.3514C134.785 66.9031 134.904 67.5144 134.904 68.1705V77.8622H134.889ZM128.727 77.5491C128.936 77.5491 129.1 77.4895 129.234 77.3553C129.368 77.2211 129.428 77.0571 129.428 76.8483V69.1993C129.428 68.9905 129.368 68.8116 129.234 68.6923C129.1 68.5581 128.936 68.4985 128.727 68.4985H116.193V76.8483C116.193 77.0571 116.253 77.236 116.387 77.3553C116.521 77.4895 116.685 77.5491 116.894 77.5491H128.727Z",
    fill: "white"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M145.693 84.1693H139.545V77.9814H145.693V84.1693Z",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M174.476 77.8621C174.476 78.5182 174.356 79.1295 174.102 79.6812C173.849 80.2329 173.521 80.71 173.118 81.1126C172.715 81.5152 172.237 81.8432 171.685 82.0818C171.133 82.3203 170.536 82.4396 169.91 82.4396H155.316C154.69 82.4396 154.093 82.3203 153.541 82.0818C152.989 81.8432 152.511 81.5301 152.108 81.1126C151.706 80.71 151.377 80.2329 151.124 79.6812C150.87 79.1295 150.751 78.5331 150.751 77.8621V73.1355H156.197V76.8333C156.197 77.042 156.257 77.221 156.391 77.3403C156.525 77.4744 156.689 77.5341 156.898 77.5341H168.328C168.537 77.5341 168.716 77.4744 168.835 77.3403C168.97 77.2061 169.029 77.042 169.029 76.8333V69.8254H154.914C154.287 69.8254 153.69 69.7061 153.138 69.4676C152.586 69.229 152.108 68.9159 151.705 68.4984C151.303 68.0958 150.974 67.6187 150.721 67.067C150.467 66.5153 150.348 65.9189 150.348 65.2479V55.9438C150.348 55.2878 150.467 54.6764 150.721 54.1248C150.974 53.5731 151.303 53.0959 151.705 52.6934C152.108 52.2908 152.586 51.9627 153.138 51.7242C153.69 51.4856 154.287 51.3663 154.914 51.3663H169.895C170.521 51.3663 171.118 51.4856 171.67 51.7242C172.222 51.9627 172.7 52.2759 173.103 52.6934C173.506 53.0959 173.834 53.5731 174.088 54.1248C174.341 54.6764 174.461 55.2878 174.461 55.9438V77.8472L174.476 77.8621ZM169.029 64.9348V56.9726C169.029 56.7639 168.97 56.585 168.835 56.4657C168.701 56.3315 168.537 56.2719 168.328 56.2719H156.495C156.286 56.2719 156.107 56.3315 155.988 56.4657C155.854 56.5999 155.794 56.7639 155.794 56.9726V64.2191C155.794 64.4278 155.854 64.6068 155.988 64.7261C156.122 64.8602 156.286 64.9199 156.495 64.9199H169.029V64.9348Z",
    fill: "white"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M185.398 84.1693H179.25V77.9814H185.398V84.1693Z",
    fill: "white"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M197.261 82.4247H191.814V56.2569H188.89V51.3663H197.246V82.4098L197.261 82.4247Z",
    fill: "white"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M210.108 82.4247H204.661V56.2569H201.737V51.3663H210.093V82.4098L210.108 82.4247Z",
    fill: "white"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M221.747 84.1693H215.599V77.9814H221.747V84.1693Z",
    fill: "white"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M231.087 85.3919C229.371 82.4993 228.178 79.562 227.506 76.565C226.82 73.568 226.477 70.6306 226.477 67.738C226.477 64.8454 226.82 61.9528 227.506 58.9707C228.193 55.9886 229.386 53.0662 231.087 50.2034H236.802C235.967 51.6199 235.235 53.0811 234.609 54.6019C233.997 56.1079 233.49 57.6138 233.087 59.1198C232.699 60.6108 232.4 62.1019 232.221 63.5482C232.042 65.0094 231.938 66.411 231.938 67.738C231.938 69.065 232.027 70.4815 232.221 71.9576C232.4 73.4338 232.699 74.9248 233.087 76.4308C233.475 77.9367 233.982 79.4576 234.609 80.9635C235.22 82.4695 235.952 83.9456 236.802 85.3919H231.087Z",
    fill: "white"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M273.121 68.409H238.816V63.6824H264.451V54.93H241.666V50.2034H269.898V63.6824H273.136V68.409H273.121ZM270.002 84.5569H241.935V71.3165H270.002V84.5569ZM264.571 79.8303V75.9685H247.381V79.8303H264.571Z",
    fill: "white"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M275.135 85.3919C275.971 83.9456 276.702 82.4695 277.329 80.9635C277.94 79.4576 278.448 77.9367 278.851 76.4308C279.239 74.9248 279.537 73.4338 279.716 71.9576C279.895 70.4815 279.985 69.0799 279.985 67.738C279.985 66.3961 279.895 64.9945 279.716 63.5482C279.537 62.087 279.239 60.6108 278.851 59.1198C278.463 57.6288 277.955 56.1228 277.329 54.6019C276.717 53.096 275.986 51.6348 275.135 50.2034H280.85C282.551 53.0662 283.76 55.9886 284.431 58.9707C285.118 61.9528 285.461 64.8752 285.461 67.738C285.461 70.6008 285.118 73.568 284.431 76.565C283.745 79.562 282.551 82.4993 280.85 85.3919H275.135Z",
    fill: "white"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M634.74 40.0345H366.767C356.113 40.0345 347.489 31.4162 347.489 20.7702C347.489 10.1242 356.113 1.50598 366.767 1.50598H634.74C645.394 1.50598 654.018 10.1242 654.018 20.7702C654.018 31.4162 645.394 40.0345 634.74 40.0345Z",
    stroke: "url(#paint2_linear_2109_83633)",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M451.132 13.9263C451.132 14.478 451.103 14.9551 451.028 15.3428C450.953 15.7454 450.834 16.0734 450.655 16.3567C450.476 16.64 450.237 16.8935 449.924 17.1022C449.61 17.311 449.223 17.5048 448.745 17.6837C447.178 18.2802 445.612 18.8617 444.045 19.4133C442.478 19.965 440.882 20.5018 439.27 21.0088L438.031 18.3845C439.434 17.8925 440.852 17.3706 442.269 16.8488C443.687 16.3269 445.089 15.7901 446.477 15.2384C447.223 14.9402 447.581 14.3587 447.581 13.4939V12.8826H439.121V9.90051H451.132V13.9412V13.9263ZM458.683 32.0872H440.792V25.4222H454.609V24.2891H440.762V21.3517H458.16V28.0167H444.343V29.1498H458.668V32.0872H458.683ZM458.16 20.5913H454.609V9.28918H458.16V13.2554H461.04V16.5207H458.16V20.5913Z",
    fill: "white"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M476.932 28.4192H462.935V17.5048H471.694V13.2554H462.906V10.1093H475.245V20.5913H466.487V25.2731H476.932V28.4192ZM481.93 32.0275H478.379V9.28918H481.93V17.6092H485.019V21.0088H481.93V32.0275Z",
    fill: "white"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M515.309 23.9611H492.882V20.8746H500.895V18.3547H504.506V20.8746H515.309V23.9611ZM513.28 19.7712H509.729V17.3707H494.747V14.3289H509.729V12.4502H494.747V9.36377H513.28V19.7712ZM513.817 31.8188H495.135V25.1241H498.687V28.6727H513.817V31.8188Z",
    fill: "white"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M530.29 28.628C529.425 27.5694 528.634 26.5704 527.918 25.631C527.202 24.6916 526.5 23.797 525.859 22.9173C525.68 22.6937 525.53 22.47 525.381 22.2613C525.232 22.0525 525.098 21.8139 524.978 21.5754C524.725 22.0525 524.426 22.4998 524.098 22.9173C523.426 23.797 522.651 24.7662 521.785 25.8248C520.905 26.8835 520.039 27.9421 519.159 28.9858L516.742 26.4362C517.756 25.2284 518.711 24.0356 519.622 22.8428C520.532 21.6499 521.367 20.5018 522.143 19.3985C522.471 18.9362 522.725 18.4144 522.889 17.8478C523.068 17.2812 523.143 16.64 523.143 15.9392V9.93035H526.754V15.9392C526.754 16.64 526.843 17.2812 527.008 17.8478C527.172 18.4144 527.425 18.9362 527.724 19.3985C528.47 20.5167 529.216 21.635 529.992 22.7533C530.768 23.8716 531.648 25.0197 532.618 26.1976L530.275 28.6131L530.29 28.628ZM537.87 32.0276H534.319V19.2195H529.634V15.8647H534.319V9.27429H537.87V32.0127V32.0276Z",
    fill: "white"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M563.266 30.5067H540.84V27.3606H563.266V30.5067ZM561.61 24.4233H542.914V9.87073H561.162V13.0168H546.465V15.5963H560.894V18.6828H546.465V21.2921H561.595V24.4382L561.61 24.4233Z",
    fill: "white"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M393.969 82.4248H370.08V71.3464C370.08 70.0343 370.408 69.0054 371.079 68.2599C371.751 67.5144 372.676 67.0224 373.855 66.7838L387.657 63.9508C387.866 63.9061 388.045 63.8017 388.164 63.6824C388.299 63.5482 388.358 63.3842 388.358 63.1755V56.9877C388.358 56.7789 388.299 56.6 388.164 56.4807C388.03 56.3465 387.866 56.2869 387.657 56.2869H376.615C376.406 56.2869 376.227 56.3465 376.108 56.4807C375.974 56.6149 375.914 56.7789 375.914 56.9877V62.2659H370.468V55.9588C370.468 55.3028 370.587 54.6915 370.841 54.1398C371.094 53.5881 371.423 53.111 371.825 52.7084C372.228 52.3058 372.706 51.9778 373.258 51.7392C373.81 51.5006 374.407 51.3813 375.033 51.3813H389.224C389.85 51.3813 390.447 51.5006 390.999 51.7392C391.551 51.9778 392.029 52.2909 392.432 52.7084C392.835 53.111 393.163 53.5881 393.417 54.1398C393.67 54.6915 393.79 55.3028 393.79 55.9588V63.9508C393.79 65.2629 393.461 66.2917 392.79 67.0373C392.118 67.7828 391.193 68.2748 390.015 68.5134L376.212 71.3166C376.003 71.3762 375.824 71.4508 375.705 71.5551C375.571 71.6595 375.511 71.8235 375.511 72.0323V77.5491H393.969V82.4397V82.4248Z",
    fill: "white"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M422.752 77.8622C422.752 78.5183 422.633 79.1296 422.379 79.6813C422.125 80.233 421.797 80.7101 421.394 81.1127C420.991 81.5153 420.514 81.8433 419.962 82.0819C419.41 82.3204 418.813 82.4397 418.186 82.4397H403.593C402.966 82.4397 402.369 82.3204 401.817 82.0819C401.265 81.8433 400.788 81.5302 400.385 81.1127C399.982 80.6952 399.654 80.233 399.4 79.6813C399.146 79.1296 399.027 78.5332 399.027 77.8622V55.9588C399.027 55.3028 399.146 54.6915 399.4 54.1398C399.654 53.5881 399.982 53.111 400.385 52.7084C400.788 52.3058 401.265 51.9778 401.817 51.7392C402.369 51.5006 402.966 51.3813 403.593 51.3813H418.186C418.813 51.3813 419.41 51.5006 419.962 51.7392C420.514 51.9778 420.991 52.2909 421.394 52.7084C421.797 53.111 422.125 53.5881 422.379 54.1398C422.633 54.6915 422.752 55.3028 422.752 55.9588V77.8622ZM416.604 77.5491C416.813 77.5491 416.992 77.4895 417.112 77.3553C417.246 77.2211 417.306 77.0571 417.306 76.8483V56.9877C417.306 56.7789 417.246 56.6 417.112 56.4807C416.977 56.3465 416.813 56.2869 416.604 56.2869H405.175C404.966 56.2869 404.787 56.3465 404.667 56.4807C404.533 56.6149 404.473 56.7789 404.473 56.9877V76.8483C404.473 77.0571 404.533 77.236 404.667 77.3553C404.802 77.4895 404.966 77.5491 405.175 77.5491H416.604Z",
    fill: "white"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M451.699 82.4248H427.81V71.3464C427.81 70.0343 428.139 69.0054 428.81 68.2599C429.482 67.5144 430.407 67.0224 431.585 66.7838L445.388 63.9508C445.597 63.9061 445.776 63.8017 445.895 63.6824C446.029 63.5482 446.089 63.3842 446.089 63.1755V56.9877C446.089 56.7789 446.029 56.6 445.895 56.4807C445.761 56.3465 445.597 56.2869 445.388 56.2869H434.346C434.137 56.2869 433.958 56.3465 433.839 56.4807C433.719 56.6149 433.645 56.7789 433.645 56.9877V62.2659H428.198V55.9588C428.198 55.3028 428.318 54.6915 428.571 54.1398C428.825 53.5881 429.153 53.111 429.556 52.7084C429.959 52.3058 430.436 51.9778 430.989 51.7392C431.541 51.5006 432.138 51.3813 432.764 51.3813H446.954C447.581 51.3813 448.178 51.5006 448.73 51.7392C449.282 51.9778 449.76 52.2909 450.163 52.7084C450.565 53.111 450.894 53.5881 451.147 54.1398C451.401 54.6915 451.52 55.3028 451.52 55.9588V63.9508C451.52 65.2629 451.192 66.2917 450.521 67.0373C449.849 67.7828 448.924 68.2748 447.745 68.5134L433.943 71.3166C433.734 71.3762 433.555 71.4508 433.436 71.5551C433.301 71.6595 433.242 71.8235 433.242 72.0323V77.5491H451.699V82.4397V82.4248Z",
    fill: "white"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M480.871 77.8622C480.871 78.5183 480.751 79.1296 480.498 79.6813C480.244 80.233 479.916 80.7101 479.513 81.1127C479.11 81.5153 478.633 81.8433 478.08 82.0819C477.528 82.3204 476.932 82.4397 476.305 82.4397H461.324C460.697 82.4397 460.1 82.3204 459.548 82.0819C458.996 81.8433 458.519 81.5302 458.116 81.1127C457.713 80.7101 457.385 80.233 457.131 79.6813C456.877 79.1296 456.758 78.5332 456.758 77.8622V55.9588C456.758 55.3028 456.877 54.6915 457.131 54.1398C457.385 53.5881 457.713 53.111 458.116 52.7084C458.519 52.3058 458.996 51.9778 459.548 51.7392C460.1 51.5006 460.697 51.3813 461.324 51.3813H475.917C476.544 51.3813 477.14 51.5006 477.693 51.7392C478.245 51.9778 478.722 52.2909 479.125 52.7084C479.528 53.111 479.856 53.5881 480.11 54.1398C480.363 54.6915 480.483 55.3028 480.483 55.9588V59.8952H475.036V56.9727C475.036 56.764 474.977 56.5851 474.843 56.4658C474.708 56.3316 474.544 56.272 474.335 56.272H462.905C462.697 56.272 462.518 56.3316 462.398 56.4658C462.264 56.6 462.204 56.764 462.204 56.9727V63.593H476.32C476.946 63.593 477.543 63.7123 478.095 63.9508C478.647 64.1894 479.125 64.5025 479.528 64.92C479.931 65.3226 480.259 65.7997 480.513 66.3514C480.766 66.9031 480.886 67.5144 480.886 68.1705V77.8622H480.871ZM474.723 77.5491C474.932 77.5491 475.096 77.4895 475.23 77.3553C475.365 77.2211 475.424 77.0571 475.424 76.8483V69.1993C475.424 68.9905 475.365 68.8116 475.23 68.6923C475.096 68.573 474.932 68.4985 474.723 68.4985H462.189V76.8483C462.189 77.0571 462.249 77.236 462.383 77.3553C462.517 77.4895 462.682 77.5491 462.891 77.5491H474.723Z",
    fill: "white"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M491.674 84.1693H485.526V77.9814H491.674V84.1693Z",
    fill: "white"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M520.457 77.8621C520.457 78.5182 520.338 79.1295 520.084 79.6812C519.83 80.2329 519.502 80.71 519.099 81.1126C518.696 81.5152 518.219 81.8432 517.667 82.0818C517.115 82.3203 516.518 82.4396 515.891 82.4396H501.298C500.671 82.4396 500.075 82.3203 499.522 82.0818C498.97 81.8432 498.493 81.5301 498.09 81.1126C497.687 80.6951 497.359 80.2329 497.105 79.6812C496.852 79.1295 496.732 78.5331 496.732 77.8621V73.1355H502.178V76.8333C502.178 77.042 502.238 77.221 502.372 77.3403C502.507 77.4744 502.671 77.5341 502.88 77.5341H514.31C514.518 77.5341 514.698 77.4744 514.817 77.3403C514.951 77.2061 515.011 77.042 515.011 76.8333V69.8254H500.895C500.269 69.8254 499.672 69.7061 499.12 69.4676C498.568 69.229 498.09 68.9159 497.687 68.4984C497.284 68.0958 496.956 67.6187 496.702 67.067C496.449 66.5153 496.329 65.9189 496.329 65.2479V55.9438C496.329 55.2878 496.449 54.6764 496.702 54.1248C496.956 53.5731 497.284 53.0959 497.687 52.6934C498.09 52.2908 498.568 51.9627 499.12 51.7242C499.672 51.4856 500.269 51.3663 500.895 51.3663H515.876C516.503 51.3663 517.1 51.4856 517.652 51.7242C518.204 51.9627 518.682 52.2759 519.084 52.6934C519.487 53.0959 519.816 53.5731 520.069 54.1248C520.323 54.6764 520.442 55.2878 520.442 55.9438V77.8472L520.457 77.8621ZM515.026 64.9348V56.9726C515.026 56.7639 514.966 56.585 514.832 56.4657C514.698 56.3315 514.533 56.2719 514.325 56.2719H502.492C502.283 56.2719 502.119 56.3315 501.985 56.4657C501.85 56.5999 501.791 56.7639 501.791 56.9726V64.2191C501.791 64.4278 501.85 64.6068 501.985 64.7261C502.119 64.8602 502.283 64.9199 502.492 64.9199H515.026V64.9348Z",
    fill: "white"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M531.38 84.1693H525.232V77.9814H531.38V84.1693Z",
    fill: "white"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M543.257 82.4247H537.811V56.2569H534.886V51.3663H543.242V82.4098L543.257 82.4247Z",
    fill: "white"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M572.906 82.4248H549.017V71.3464C549.017 70.0343 549.345 69.0054 550.016 68.2599C550.688 67.5144 551.613 67.0224 552.792 66.7838L566.594 63.9508C566.803 63.9061 566.967 63.8017 567.101 63.6824C567.236 63.5482 567.295 63.3842 567.295 63.1755V56.9877C567.295 56.7789 567.236 56.6 567.101 56.4807C566.967 56.3465 566.803 56.2869 566.594 56.2869H555.552C555.343 56.2869 555.179 56.3465 555.045 56.4807C554.911 56.6149 554.851 56.7789 554.851 56.9877V62.2659H549.405V55.9588C549.405 55.3028 549.524 54.6915 549.778 54.1398C550.031 53.5881 550.359 53.111 550.762 52.7084C551.165 52.3058 551.643 51.9778 552.195 51.7392C552.747 51.5006 553.344 51.3813 553.971 51.3813H568.161C568.787 51.3813 569.384 51.5006 569.936 51.7392C570.488 51.9778 570.966 52.2909 571.369 52.7084C571.772 53.111 572.1 53.5881 572.354 54.1398C572.607 54.6915 572.727 55.3028 572.727 55.9588V63.9508C572.727 65.2629 572.398 66.2917 571.727 67.0373C571.055 67.7828 570.13 68.2748 568.952 68.5134L555.149 71.3166C554.94 71.3762 554.776 71.4508 554.642 71.5551C554.508 71.6595 554.448 71.8235 554.448 72.0323V77.5491H572.906V82.4397V82.4248Z",
    fill: "white"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M583.828 84.1693H577.68V77.9814H583.828V84.1693Z",
    fill: "white"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M593.169 85.3919C591.453 82.4993 590.259 79.562 589.573 76.565C588.886 73.568 588.543 70.6306 588.543 67.738C588.543 64.8454 588.886 61.9528 589.573 58.9707C590.259 55.9886 591.453 53.0662 593.169 50.2034H598.884C598.048 51.6199 597.317 53.0811 596.69 54.6019C596.079 56.1079 595.571 57.6138 595.168 59.1198C594.765 60.6108 594.482 62.1019 594.303 63.5482C594.124 65.0094 594.019 66.411 594.019 67.738C594.019 69.065 594.109 70.4815 594.303 71.9576C594.482 73.4338 594.78 74.9248 595.168 76.4308C595.556 77.9367 596.064 79.4576 596.69 80.9635C597.302 82.4695 598.033 83.9456 598.884 85.3919H593.169Z",
    fill: "white"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M635.202 82.5441H600.898V77.7429H615.491V72.7032H604.091V50.9937H632.009V55.7948H609.538V59.4628H631.621V64.1894H609.538V67.8871H632.681V72.6883H621.012V77.728H635.202V82.5292V82.5441Z",
    fill: "white"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M637.217 85.3919C638.052 83.9456 638.784 82.4695 639.41 80.9635C640.022 79.4576 640.529 77.9367 640.932 76.4308C641.32 74.9248 641.619 73.4338 641.798 71.9576C641.977 70.4815 642.066 69.0799 642.066 67.738C642.066 66.3961 641.977 64.9945 641.798 63.5482C641.619 62.087 641.32 60.6108 640.932 59.1198C640.544 57.6288 640.037 56.1228 639.41 54.6019C638.798 53.096 638.067 51.6348 637.217 50.2034H642.932C644.633 53.0662 645.841 55.9886 646.513 58.9707C647.199 61.9528 647.542 64.8752 647.542 67.738C647.542 70.6008 647.199 73.568 646.513 76.565C645.826 79.562 644.633 82.4993 642.932 85.3919H637.217Z",
    fill: "white"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M673.744 1.50598V88.8511",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M980.737 0H716.494C705.847 0 697.216 8.62489 697.216 19.2642V74.388C697.216 85.0273 705.847 93.6522 716.494 93.6522H980.737C991.384 93.6522 1000.02 85.0273 1000.02 74.388V19.2642C1000.02 8.62489 991.384 0 980.737 0Z",
    fill: "url(#paint3_linear_2109_83633)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M772.972 25.959H749.784V21.2324H753.335V11.5853H750.187V6.85874H772.39V11.5853H768.958V21.2324H772.986V25.959H772.972ZM781.372 40.2282H753.962V28.7174H759.408V35.4122H781.372V40.2133V40.2282ZM763.511 21.2324V11.5853H758.781V21.2324H763.511ZM780.537 31.446H775.09V5.75537H780.537V13.9859H784.953V18.9958H780.537V31.446Z",
    fill: "white"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M821.033 38.2154H786.729V33.4142H793.787V21.3219H799.233V33.4142H803.411V21.3219H808.857V33.4142H821.033V38.2154ZM817.646 28.2851H812.2V11.824H789.728V7.02283H817.646V28.3V28.2851Z",
    fill: "white"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M855.263 25.3775H849.816V22.4998H842.162C841.237 23.2602 840.177 23.8716 838.954 24.3189C837.73 24.7662 836.372 24.9898 834.88 24.9898C833.254 24.9898 831.791 24.7364 830.478 24.2145C829.18 23.7076 828.061 23.0068 827.151 22.1271C826.226 21.2473 825.524 20.2185 825.017 19.0406C824.525 17.8627 824.271 16.6102 824.271 15.2981C824.271 13.986 824.525 12.7335 825.017 11.5556C825.509 10.3777 826.226 9.34883 827.151 8.46912C828.076 7.58941 829.18 6.88862 830.478 6.38166C831.776 5.87471 833.239 5.60632 834.88 5.60632C836.522 5.60632 838.073 5.87471 839.416 6.4264C840.759 6.97808 841.893 7.7236 842.803 8.67787H849.816V5.75543H855.263V25.3775ZM855.263 40.616H849.816V31.5206H827.658V26.7195H855.263V40.6309V40.616ZM834.88 20.2483C836.477 20.2483 837.745 19.7861 838.67 18.8766C839.595 17.9521 840.058 16.7593 840.058 15.2981C840.058 13.8369 839.595 12.6291 838.67 11.7196C837.745 10.7951 836.492 10.3478 834.88 10.3478C833.269 10.3478 832.015 10.8101 831.09 11.7196C830.165 12.6291 829.717 13.8369 829.717 15.2981C829.717 16.7593 830.18 17.967 831.09 18.8766C832.015 19.801 833.269 20.2483 834.88 20.2483ZM849.816 17.6539V13.5237H845.325C845.385 13.807 845.415 14.1053 845.444 14.4035C845.474 14.7017 845.489 14.9999 845.489 15.2832C845.489 16.0734 845.385 16.8637 845.176 17.6539H849.831H849.816Z",
    fill: "white"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M894.058 24.7065H870.169V20.129H876.958V14.806H882.479V20.129H894.073V24.7065H894.058ZM892.283 18.7125H886.836V10.8249H871.617V6.26232H892.283V18.7125ZM881.435 40.4668C880.301 40.4668 879.256 40.3028 878.301 39.9897C877.346 39.6765 876.511 39.2143 875.81 38.6328C875.108 38.0364 874.571 37.3058 874.168 36.441C873.78 35.5762 873.571 34.607 873.571 33.5185C873.571 32.4301 873.765 31.4758 874.168 30.5961C874.556 29.7313 875.108 29.0007 875.81 28.4043C876.511 27.8079 877.331 27.3605 878.301 27.0474C879.256 26.7343 880.301 26.5703 881.435 26.5703H894.133C895.267 26.5703 896.311 26.7343 897.266 27.0474C898.221 27.3605 899.057 27.8228 899.758 28.4043C900.46 29.0007 900.997 29.7313 901.4 30.5961C901.788 31.4609 901.996 32.4301 901.996 33.5185C901.996 34.607 901.802 35.5613 901.4 36.441C901.012 37.3058 900.46 38.0364 899.758 38.6328C899.057 39.2292 898.236 39.6765 897.266 39.9897C896.311 40.3028 895.267 40.4668 894.133 40.4668H881.435ZM893.551 35.8147C894.491 35.8147 895.237 35.606 895.759 35.2034C896.282 34.8008 896.55 34.2342 896.55 33.5334C896.55 32.8327 896.282 32.2661 895.759 31.8635C895.237 31.4609 894.491 31.2522 893.551 31.2522H882.032C881.092 31.2522 880.346 31.4609 879.823 31.8635C879.301 32.2661 879.032 32.8327 879.032 33.5334C879.032 34.2342 879.301 34.8008 879.823 35.2034C880.346 35.606 881.092 35.8147 882.032 35.8147H893.551ZM901.071 25.7353H895.625V5.75537H901.071V13.1211H905.205V18.131H901.071V25.7353Z",
    fill: "white"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M926.423 24.0803C925.005 23.0514 923.632 22.0524 922.319 21.0684C921.006 20.0843 919.678 19.0853 918.335 18.0863C916.918 19.1896 915.47 20.293 914.023 21.3964C912.561 22.4998 911.084 23.6031 909.592 24.7065L906.324 21.128C907.667 20.0992 909.01 19.0704 910.367 18.0117C911.725 16.968 913.053 15.8944 914.366 14.8209C915.187 14.135 915.59 13.1808 915.59 11.9432V11.317H907.861V6.66491H928.601V11.317H921.111V11.9432C921.111 13.1808 921.514 14.135 922.334 14.8209C923.468 15.7901 924.647 16.7592 925.886 17.7135C927.124 18.6678 928.348 19.5922 929.556 20.4868L926.438 24.0653L926.423 24.0803ZM917.828 40.4668C916.694 40.4668 915.65 40.3028 914.695 39.9598C913.74 39.6169 912.904 39.1249 912.218 38.4837C911.516 37.8426 910.979 37.0523 910.576 36.1428C910.188 35.2183 909.979 34.1895 909.979 33.0265C909.979 31.8635 910.173 30.8347 910.576 29.9102C910.964 28.9858 911.516 28.2104 912.218 27.5693C912.919 26.9281 913.74 26.4361 914.695 26.0932C915.65 25.7502 916.694 25.5862 917.828 25.5862H930.526C931.66 25.5862 932.705 25.7502 933.66 26.0932C934.615 26.4361 935.45 26.9281 936.137 27.5693C936.838 28.2104 937.375 29.0007 937.778 29.9102C938.166 30.8347 938.375 31.8635 938.375 33.0265C938.375 34.1895 938.181 35.2183 937.778 36.1428C937.39 37.0672 936.838 37.8426 936.137 38.4837C935.435 39.1249 934.615 39.6169 933.66 39.9598C932.705 40.3028 931.66 40.4668 930.526 40.4668H917.828ZM929.944 35.7402C930.884 35.7402 931.63 35.5016 932.153 35.0245C932.675 34.5474 932.943 33.8764 932.943 33.0116C932.943 32.1468 932.675 31.4758 932.153 30.9987C931.63 30.5215 930.884 30.283 929.944 30.283H918.425C917.485 30.283 916.739 30.5215 916.217 30.9987C915.694 31.4758 915.426 32.1468 915.426 33.0116C915.426 33.8764 915.694 34.5474 916.217 35.0245C916.739 35.5016 917.485 35.7402 918.425 35.7402H929.944ZM937.465 24.7065H932.018V5.75537H937.465V12.2563H941.881V17.2662H937.465V24.7065Z",
    fill: "white"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M794.07 86.7934H788.788V70.049H785.118V81.9028H769.704V54.5124H785.118V64.8304H788.788V53.409H794.07V86.7785V86.7934ZM779.761 77.1017V59.3285H775.076V77.1017H779.761ZM801.919 87.7775H796.562V53.0214H801.919V87.7775Z",
    fill: "white"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M826.748 66.8284C826.256 68.0361 825.525 69.0948 824.599 70.0043C823.659 70.9138 822.54 71.6295 821.212 72.1514C819.884 72.6733 818.392 72.9416 816.736 72.9416C815.08 72.9416 813.587 72.6733 812.259 72.1514C810.931 71.6295 809.797 70.9138 808.872 70.0043C807.947 69.0948 807.216 68.0361 806.709 66.8284C806.201 65.6206 805.948 64.3532 805.948 63.0113C805.948 61.6694 806.201 60.402 806.709 59.1943C807.216 57.9865 807.947 56.9279 808.872 56.0183C809.812 55.1088 810.931 54.3931 812.259 53.8712C813.587 53.3494 815.08 53.081 816.736 53.081C818.392 53.081 819.884 53.3494 821.212 53.8712C822.54 54.3931 823.674 55.1088 824.599 56.0183C825.525 56.9279 826.256 57.9865 826.763 59.1943C827.27 60.402 827.539 61.6843 827.539 63.0113C827.539 64.3383 827.27 65.6206 826.748 66.8284ZM837.76 87.5091H809.723V75.2229H815.169V82.708H837.76V87.5091ZM816.736 68.2001C818.392 68.2001 819.705 67.7081 820.66 66.7389C821.615 65.7697 822.093 64.5173 822.093 62.9964C822.093 61.4755 821.615 60.2231 820.66 59.2539C819.705 58.2847 818.392 57.7927 816.736 57.7927C815.08 57.7927 813.767 58.2847 812.812 59.2539C811.857 60.2231 811.379 61.4755 811.379 62.9964C811.379 64.5173 811.857 65.7697 812.812 66.7389C813.767 67.7081 815.08 68.2001 816.736 68.2001ZM836.925 77.9366H831.478V53.0363H836.925V77.9366Z",
    fill: "white"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M886.284 77.6235H871.9V87.8223H866.379V77.6235H851.98V72.8224H886.284V77.6235ZM882.897 69.4228H855.382V53.6178H882.897V69.4228ZM877.451 64.6217V58.4339H860.813V64.6217H877.451Z",
    fill: "white"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M906.04 81.9177H890.149V54.5273H905.055V59.3284H895.506V77.1016H906.04V81.9028V81.9177ZM922.17 87.7775H916.813V70.4367H913.546V86.7934H908.263V53.4239H913.546V65.2479H916.813V53.0363H922.17V87.7924V87.7775Z",
    fill: "white"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M393.148 480.339C439.75 480.339 477.529 442.588 477.529 396.02C477.529 349.453 439.75 311.702 393.148 311.702C346.546 311.702 308.768 349.453 308.768 396.02C308.768 442.588 346.546 480.339 393.148 480.339Z",
    fill: "url(#paint4_radial_2109_83633)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M393.133 310.256C345.818 310.256 307.321 348.725 307.321 396.005C307.321 443.286 345.818 481.785 393.133 481.785C440.449 481.785 478.976 443.301 478.976 396.005C478.976 348.71 440.464 310.256 393.133 310.256ZM393.133 487.794C342.49 487.794 301.292 446.626 301.292 396.005C301.292 345.385 342.49 304.247 393.133 304.247C443.777 304.247 484.989 345.414 484.989 396.005C484.989 446.596 443.777 487.794 393.133 487.794Z",
    fill: "url(#paint5_linear_2109_83633)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M393.134 310.405C345.893 310.405 307.455 348.814 307.455 396.02C307.455 443.227 345.893 481.651 393.134 481.651C440.375 481.651 478.827 443.242 478.827 396.02C478.827 348.799 440.39 310.405 393.134 310.405ZM301.606 396.005C301.606 345.578 342.67 304.56 393.134 304.56C443.598 304.56 484.676 345.578 484.676 396.005C484.676 446.432 443.613 487.481 393.134 487.481C342.655 487.481 301.606 446.447 301.606 396.005Z",
    fill: "url(#paint6_linear_2109_83633)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M393.133 310.539C345.967 310.539 307.589 348.874 307.589 396.005C307.589 443.137 345.967 481.502 393.133 481.502C440.3 481.502 478.692 443.152 478.692 396.005C478.692 348.859 440.315 310.539 393.133 310.539ZM301.919 396.005C301.919 345.757 342.833 304.873 393.133 304.873C443.433 304.873 484.362 345.757 484.362 396.005C484.362 446.253 443.433 487.168 393.133 487.168C342.833 487.168 301.919 446.268 301.919 396.005Z",
    fill: "url(#paint7_linear_2109_83633)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M393.133 310.688C346.042 310.688 307.723 348.963 307.723 396.02C307.723 443.078 346.042 481.367 393.133 481.367C440.225 481.367 478.558 443.078 478.558 396.02C478.558 348.963 440.24 310.688 393.133 310.688ZM302.232 396.005C302.232 345.921 343.013 305.186 393.133 305.186C443.254 305.186 484.049 345.921 484.049 396.005C484.049 446.089 443.269 486.84 393.133 486.84C342.998 486.84 302.232 446.089 302.232 396.005Z",
    fill: "url(#paint8_linear_2109_83633)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M393.134 310.822C346.116 310.822 307.858 349.038 307.858 396.005C307.858 442.973 346.116 481.218 393.134 481.218C440.151 481.218 478.424 442.988 478.424 396.005C478.424 349.023 440.166 310.822 393.134 310.822ZM302.546 396.005C302.546 346.1 343.192 305.499 393.134 305.499C443.075 305.499 483.736 346.1 483.736 396.005C483.736 445.911 443.09 486.526 393.134 486.526C343.177 486.526 302.546 445.911 302.546 396.005Z",
    fill: "url(#paint9_linear_2109_83633)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M393.134 310.971C346.191 310.971 308.007 349.127 308.007 396.02C308.007 442.914 346.191 481.084 393.134 481.084C440.076 481.084 478.275 442.928 478.275 396.02C478.275 349.112 440.076 310.971 393.134 310.971ZM302.859 396.005C302.859 346.279 343.356 305.812 393.134 305.812C442.911 305.812 483.423 346.264 483.423 396.005C483.423 445.746 442.926 486.213 393.134 486.213C343.341 486.213 302.859 445.746 302.859 396.005Z",
    fill: "url(#paint10_linear_2109_83633)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M393.133 311.106C346.265 311.106 308.141 349.187 308.141 396.005C308.141 442.824 346.265 480.935 393.133 480.935C440.001 480.935 478.14 442.839 478.14 396.005C478.14 349.172 440.001 311.106 393.133 311.106ZM303.172 396.005C303.172 346.443 343.535 306.141 393.133 306.141C442.732 306.141 483.109 346.458 483.109 396.005C483.109 445.553 442.747 485.9 393.133 485.9C343.52 485.9 303.172 445.568 303.172 396.005Z",
    fill: "url(#paint11_linear_2109_83633)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M393.133 311.255C346.34 311.255 308.276 349.276 308.276 396.02C308.276 442.765 346.34 480.801 393.133 480.801C439.927 480.801 478.006 442.765 478.006 396.02C478.006 349.276 439.942 311.255 393.133 311.255ZM303.486 396.005C303.486 346.622 343.699 306.454 393.133 306.454C442.568 306.454 482.796 346.622 482.796 396.005C482.796 445.389 442.568 485.587 393.133 485.587C343.699 485.587 303.486 445.404 303.486 396.005Z",
    fill: "url(#paint12_linear_2109_83633)"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M393.134 311.389C346.415 311.389 308.41 349.351 308.41 396.005C308.41 442.66 346.415 480.652 393.134 480.652C439.852 480.652 477.857 442.675 477.857 396.005C477.857 349.336 439.852 311.389 393.134 311.389ZM303.799 396.005C303.799 346.801 343.878 306.767 393.148 306.767C442.419 306.767 482.498 346.801 482.498 396.005C482.498 445.21 442.419 485.274 393.148 485.274C343.878 485.274 303.799 445.225 303.799 396.005Z",
    fill: "url(#paint13_linear_2109_83633)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M393.149 311.523C346.504 311.523 308.559 349.425 308.559 396.005C308.559 442.586 346.504 480.503 393.149 480.503C439.793 480.503 477.738 442.6 477.738 396.005C477.738 349.41 439.793 311.523 393.149 311.523ZM304.113 396.02C304.113 346.98 344.057 307.095 393.149 307.095C442.24 307.095 482.184 346.98 482.184 396.02C482.184 445.061 442.24 484.961 393.149 484.961C344.057 484.961 304.113 445.061 304.113 396.02Z",
    fill: "url(#paint14_linear_2109_83633)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M393.148 311.672C346.579 311.672 308.693 349.5 308.693 396.02C308.693 442.541 346.579 480.383 393.148 480.383C439.718 480.383 477.603 442.541 477.603 396.02C477.603 349.5 439.718 311.672 393.148 311.672ZM304.426 396.02C304.426 347.159 344.221 307.408 393.148 307.408C442.075 307.408 481.871 347.159 481.871 396.02C481.871 444.882 442.075 484.648 393.148 484.648C344.221 484.648 304.426 444.882 304.426 396.02Z",
    fill: "url(#paint15_linear_2109_83633)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M393.148 311.806C346.653 311.806 308.843 349.574 308.843 396.005C308.843 442.436 346.668 480.219 393.148 480.219C439.628 480.219 477.469 442.436 477.469 396.005C477.469 349.574 439.643 311.806 393.148 311.806ZM304.739 396.02C304.739 347.338 344.4 307.721 393.148 307.721C441.896 307.721 481.557 347.323 481.557 396.02C481.557 444.718 441.896 484.335 393.148 484.335C344.4 484.335 304.739 444.718 304.739 396.02Z",
    fill: "url(#paint16_linear_2109_83633)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M393.148 311.956C346.728 311.956 308.977 349.664 308.977 396.02C308.977 442.377 346.743 480.1 393.148 480.1C439.554 480.1 477.32 442.377 477.32 396.02C477.32 349.664 439.554 311.956 393.148 311.956ZM305.053 396.02C305.053 347.502 344.579 308.034 393.148 308.034C441.718 308.034 481.244 347.502 481.244 396.02C481.244 444.539 441.718 484.022 393.148 484.022C344.579 484.022 305.053 444.539 305.053 396.02Z",
    fill: "url(#paint17_linear_2109_83633)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M393.148 312.09C346.803 312.09 309.111 349.738 309.111 396.005C309.111 442.272 346.803 479.951 393.148 479.951C439.494 479.951 477.186 442.302 477.186 396.005C477.186 349.709 439.479 312.09 393.148 312.09ZM305.351 396.02C305.351 347.681 344.729 308.362 393.133 308.362C441.538 308.362 480.916 347.681 480.916 396.02C480.916 444.36 441.538 483.708 393.133 483.708C344.729 483.708 305.351 444.375 305.351 396.02Z",
    fill: "url(#paint18_linear_2109_83633)"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M393.149 312.239C346.892 312.239 309.246 349.828 309.246 396.02C309.246 442.213 346.877 479.817 393.149 479.817C439.42 479.817 477.051 442.228 477.051 396.02C477.051 349.813 439.42 312.239 393.149 312.239ZM305.665 396.02C305.665 347.86 344.908 308.675 393.134 308.675C441.359 308.675 480.603 347.86 480.603 396.02C480.603 444.181 441.359 483.395 393.134 483.395C344.908 483.395 305.665 444.196 305.665 396.02Z",
    fill: "url(#paint19_linear_2109_83633)"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M393.149 312.373C346.967 312.373 309.38 349.888 309.38 396.005C309.38 442.123 346.952 479.668 393.149 479.668C439.345 479.668 476.917 442.138 476.917 396.005C476.917 349.873 439.345 312.373 393.149 312.373ZM305.978 396.02C305.978 348.024 345.072 308.988 393.134 308.988C441.195 308.988 480.289 348.024 480.289 396.02C480.289 444.017 441.195 483.067 393.134 483.067C345.072 483.067 305.978 444.017 305.978 396.02Z",
    fill: "url(#paint20_linear_2109_83633)"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M476.768 396.02C476.768 349.977 439.255 312.522 393.148 312.522C347.041 312.522 309.514 349.977 309.514 396.02C309.514 442.064 347.026 479.533 393.148 479.533C439.27 479.533 476.768 442.064 476.768 396.02ZM306.291 396.02C306.291 348.203 345.251 309.301 393.148 309.301C441.046 309.301 479.991 348.203 479.991 396.02C479.991 443.838 441.031 482.754 393.148 482.754C345.266 482.754 306.291 443.838 306.291 396.02Z",
    fill: "url(#paint21_linear_2109_83633)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M391.671 377.144H353.577V370.583H381.212V363.426H355.562V356.866H389.672V370.583H391.656V377.144H391.671ZM389.687 394.842H381.226V390.876L377.257 394.842H355.577V379.306H389.687V394.842ZM381.226 388.282V385.866H364.037V388.282H381.226Z",
    fill: "#BC912F"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M415.561 377.099C414.068 376.1 412.591 375.056 411.129 373.998C409.682 372.939 408.264 371.746 406.921 370.419C405.533 371.687 404.101 372.865 402.624 373.953C401.147 375.041 399.55 376.16 397.849 377.278L393.014 371.537C394.626 370.33 396.133 369.167 397.521 368.048C398.923 366.93 400.221 365.722 401.43 364.425C401.833 364.023 402.087 363.635 402.206 363.262C402.325 362.889 402.385 362.397 402.385 361.801V356.746H411.457V361.756C411.457 362.308 411.517 362.785 411.636 363.173C411.756 363.575 411.994 363.978 412.367 364.38C413.546 365.648 414.8 366.841 416.128 367.989C417.456 369.122 418.858 370.3 420.365 371.508L415.576 377.114L415.561 377.099ZM422.633 378.262C424.125 378.262 425.424 378.486 426.513 378.948C427.602 379.41 428.512 380.036 429.214 380.827C429.915 381.617 430.437 382.541 430.795 383.585C431.138 384.629 431.318 385.732 431.318 386.88C431.318 388.028 431.138 389.132 430.78 390.175C430.422 391.219 429.885 392.144 429.169 392.934C428.453 393.724 427.527 394.35 426.423 394.813C425.319 395.275 424.006 395.498 422.514 395.498H404.728C403.236 395.498 401.937 395.275 400.863 394.813C399.789 394.35 398.893 393.724 398.207 392.934C397.521 392.144 396.998 391.219 396.67 390.175C396.342 389.132 396.178 388.028 396.178 386.88C396.178 385.732 396.357 384.629 396.7 383.585C397.043 382.541 397.565 381.617 398.282 380.827C398.983 380.036 399.893 379.41 400.982 378.948C402.072 378.486 403.37 378.262 404.862 378.262H422.648H422.633ZM420.694 388.491C421.35 388.491 421.887 388.342 422.275 388.058C422.663 387.775 422.857 387.387 422.857 386.895C422.857 386.403 422.663 386.015 422.29 385.702C421.917 385.404 421.38 385.255 420.694 385.255H406.787C406.1 385.255 405.563 385.404 405.19 385.702C404.817 386.001 404.623 386.403 404.623 386.895C404.623 387.387 404.817 387.775 405.205 388.058C405.593 388.342 406.115 388.491 406.787 388.491H420.694ZM429.855 377.278H421.395V356.731H429.855V362.681H434.093V369.927H429.855V377.263V377.278Z",
    fill: "#BC912F"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M352.876 428.913C352.876 429.748 352.622 430.434 352.1 430.941C351.578 431.462 350.906 431.716 350.071 431.716H338.686C337.85 431.716 337.164 431.462 336.656 430.941C336.134 430.419 335.88 429.748 335.88 428.913V423.292H339.059V428.421C339.059 428.749 339.223 428.913 339.551 428.913H349.22C349.548 428.913 349.712 428.749 349.712 428.421V420.414C349.712 420.086 349.548 419.922 349.22 419.922H336.119V407.636H352.025V410.454H339.297V417.119H350.071C350.906 417.119 351.578 417.372 352.1 417.894C352.622 418.416 352.876 419.087 352.876 419.922V428.913Z",
    fill: "#BC912F"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M373.408 428.913C373.408 429.748 373.154 430.434 372.632 430.941C372.109 431.462 371.438 431.716 370.602 431.716H359.411C358.576 431.716 357.889 431.462 357.382 430.941C356.86 430.419 356.606 429.748 356.606 428.913V410.454C356.606 409.619 356.86 408.948 357.382 408.426C357.904 407.904 358.576 407.651 359.411 407.651H370.602C371.438 407.651 372.109 407.904 372.632 408.426C373.154 408.948 373.408 409.619 373.408 410.454V428.913ZM369.737 428.913C370.065 428.913 370.229 428.749 370.229 428.421V410.931C370.229 410.603 370.065 410.439 369.737 410.439H360.247C359.919 410.439 359.755 410.603 359.755 410.931V428.421C359.755 428.749 359.919 428.913 360.247 428.913H369.737Z",
    fill: "#BC912F"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M394.029 428.913C394.029 429.748 393.775 430.434 393.253 430.941C392.731 431.462 392.059 431.716 391.224 431.716H380.033C379.197 431.716 378.511 431.462 378.003 430.941C377.481 430.419 377.228 429.748 377.228 428.913V410.454C377.228 409.619 377.481 408.948 378.003 408.426C378.526 407.904 379.197 407.651 380.033 407.651H391.224C392.059 407.651 392.731 407.904 393.253 408.426C393.775 408.948 394.029 409.619 394.029 410.454V428.913ZM390.358 428.913C390.687 428.913 390.851 428.749 390.851 428.421V410.931C390.851 410.603 390.687 410.439 390.358 410.439H380.868C380.54 410.439 380.376 410.603 380.376 410.931V428.421C380.376 428.749 380.54 428.913 380.868 428.913H390.358Z",
    fill: "#BC912F"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M412.442 421.323H397.58V407.591H412.442V421.323ZM420.679 433.252H400.027V424.141H403.206V430.434H420.679V433.252ZM409.264 418.52V410.424H400.759V418.52H409.264ZM420.037 426.244H416.859V406.741H420.037V413.615H423.618V416.492H420.037V426.244Z",
    fill: "#BC912F"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M444.299 421.055H436.107V425.767H432.929V421.055H425.647V418.237H444.314V421.055H444.299ZM442.762 413.958C442.434 414.569 441.926 415.106 441.225 415.568C440.524 416.03 439.673 416.388 438.644 416.641C437.614 416.895 436.42 417.029 435.048 417.029C433.675 417.029 432.451 416.91 431.437 416.641C430.422 416.388 429.557 416.03 428.87 415.568C428.184 415.106 427.662 414.569 427.318 413.943C426.975 413.316 426.811 412.645 426.811 411.915C426.811 411.184 426.975 410.498 427.318 409.887C427.662 409.261 428.169 408.724 428.87 408.262C429.557 407.8 430.422 407.442 431.437 407.173C432.451 406.905 433.66 406.771 435.048 406.771C436.435 406.771 437.614 406.905 438.644 407.173C439.673 407.442 440.539 407.8 441.225 408.262C441.912 408.724 442.434 409.261 442.777 409.887C443.12 410.513 443.284 411.184 443.284 411.915C443.284 412.645 443.105 413.331 442.762 413.958ZM450.267 433.252H428.691V425.603H431.869V430.583H450.253V433.237L450.267 433.252ZM438.853 413.585C439.688 413.123 440.106 412.556 440.106 411.9C440.106 411.244 439.688 410.677 438.853 410.2C438.017 409.723 436.749 409.484 435.063 409.484C433.376 409.484 432.108 409.723 431.273 410.2C430.437 410.677 430.019 411.244 430.019 411.9C430.019 412.556 430.437 413.108 431.273 413.585C432.108 414.047 433.376 414.286 435.063 414.286C436.749 414.286 438.017 414.047 438.853 413.585ZM449.626 427.78H446.448V425.603H439.718V422.919H446.448V406.741H449.626V427.78Z",
    fill: "#BC912F"
  }))), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M609.225 480.339C655.827 480.339 693.605 442.588 693.605 396.02C693.605 349.453 655.827 311.702 609.225 311.702C562.623 311.702 524.844 349.453 524.844 396.02C524.844 442.588 562.623 480.339 609.225 480.339Z",
    fill: "url(#paint22_radial_2109_83633)"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M609.21 310.256C561.894 310.256 523.397 348.725 523.397 396.005C523.397 443.286 561.894 481.785 609.21 481.785C656.525 481.785 695.052 443.301 695.052 396.005C695.052 348.71 656.54 310.256 609.21 310.256ZM609.21 487.794C558.567 487.794 517.369 446.626 517.369 396.005C517.369 345.385 558.567 304.247 609.21 304.247C659.853 304.247 701.066 345.414 701.066 396.005C701.066 446.596 659.853 487.794 609.21 487.794Z",
    fill: "url(#paint23_linear_2109_83633)"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M609.21 310.405C561.969 310.405 523.531 348.814 523.531 396.02C523.531 443.227 561.969 481.651 609.21 481.651C656.451 481.651 694.903 443.242 694.903 396.02C694.903 348.799 656.466 310.405 609.21 310.405ZM517.697 396.005C517.697 345.578 558.761 304.56 609.225 304.56C659.689 304.56 700.767 345.578 700.767 396.005C700.767 446.432 659.704 487.481 609.225 487.481C558.746 487.481 517.697 446.447 517.697 396.005Z",
    fill: "url(#paint24_linear_2109_83633)"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M609.21 310.539C562.043 310.539 523.665 348.874 523.665 396.005C523.665 443.137 562.043 481.502 609.21 481.502C656.376 481.502 694.769 443.152 694.769 396.005C694.769 348.859 656.391 310.539 609.21 310.539ZM518.01 396.005C518.01 345.757 558.925 304.873 609.225 304.873C659.524 304.873 700.454 345.757 700.454 396.005C700.454 446.253 659.524 487.168 609.225 487.168C558.925 487.168 518.01 446.268 518.01 396.005Z",
    fill: "url(#paint25_linear_2109_83633)"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M609.224 310.688C562.133 310.688 523.815 348.963 523.815 396.02C523.815 443.078 562.133 481.367 609.224 481.367C656.316 481.367 694.649 443.078 694.649 396.02C694.649 348.963 656.331 310.688 609.224 310.688ZM518.323 396.005C518.323 345.921 559.104 305.186 609.224 305.186C659.345 305.186 700.14 345.921 700.14 396.005C700.14 446.089 659.36 486.84 609.224 486.84C559.089 486.84 518.323 446.089 518.323 396.005Z",
    fill: "url(#paint26_linear_2109_83633)"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M609.225 310.822C562.207 310.822 523.949 349.038 523.949 396.005C523.949 442.973 562.207 481.218 609.225 481.218C656.242 481.218 694.515 442.988 694.515 396.005C694.515 349.023 656.257 310.822 609.225 310.822ZM518.622 396.005C518.622 346.1 559.268 305.499 609.21 305.499C659.151 305.499 699.812 346.1 699.812 396.005C699.812 445.911 659.166 486.526 609.21 486.526C559.253 486.526 518.622 445.911 518.622 396.005Z",
    fill: "url(#paint27_linear_2109_83633)"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M609.224 310.971C562.282 310.971 524.098 349.127 524.098 396.02C524.098 442.914 562.282 481.084 609.224 481.084C656.167 481.084 694.366 442.928 694.366 396.02C694.366 349.112 656.167 310.971 609.224 310.971ZM518.935 396.005C518.935 346.279 559.432 305.812 609.21 305.812C658.987 305.812 699.499 346.264 699.499 396.005C699.499 445.746 659.002 486.213 609.21 486.213C559.417 486.213 518.935 445.746 518.935 396.005Z",
    fill: "url(#paint28_linear_2109_83633)"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M609.225 311.106C562.357 311.106 524.233 349.187 524.233 396.005C524.233 442.824 562.357 480.935 609.225 480.935C656.093 480.935 694.232 442.839 694.232 396.005C694.232 349.172 656.093 311.106 609.225 311.106ZM519.249 396.005C519.249 346.443 559.611 306.141 609.21 306.141C658.808 306.141 699.186 346.458 699.186 396.005C699.186 445.553 658.823 485.9 609.21 485.9C559.596 485.9 519.249 445.568 519.249 396.005Z",
    fill: "url(#paint29_linear_2109_83633)"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M609.224 311.255C562.431 311.255 524.367 349.276 524.367 396.02C524.367 442.765 562.431 480.801 609.224 480.801C656.018 480.801 694.097 442.765 694.097 396.02C694.097 349.276 656.033 311.255 609.224 311.255ZM519.562 396.005C519.562 346.622 559.775 306.454 609.21 306.454C658.644 306.454 698.872 346.622 698.872 396.005C698.872 445.389 658.644 485.587 609.21 485.587C559.775 485.587 519.562 445.404 519.562 396.005Z",
    fill: "url(#paint30_linear_2109_83633)"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M609.225 311.389C562.506 311.389 524.501 349.351 524.501 396.005C524.501 442.66 562.506 480.652 609.225 480.652C655.943 480.652 693.948 442.675 693.948 396.005C693.948 349.336 655.943 311.389 609.225 311.389ZM519.875 396.005C519.875 346.801 559.954 306.767 609.225 306.767C658.495 306.767 698.574 346.801 698.574 396.005C698.574 445.21 658.495 485.274 609.225 485.274C559.954 485.274 519.875 445.225 519.875 396.005Z",
    fill: "url(#paint31_linear_2109_83633)"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M609.225 311.523C562.58 311.523 524.635 349.425 524.635 396.005C524.635 442.586 562.58 480.503 609.225 480.503C655.869 480.503 693.814 442.6 693.814 396.005C693.814 349.41 655.869 311.523 609.225 311.523ZM520.189 396.02C520.189 346.98 560.133 307.095 609.225 307.095C658.316 307.095 698.26 346.98 698.26 396.02C698.26 445.061 658.316 484.961 609.225 484.961C560.133 484.961 520.189 445.061 520.189 396.02Z",
    fill: "url(#paint32_linear_2109_83633)"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M609.225 311.672C562.655 311.672 524.77 349.5 524.77 396.02C524.77 442.541 562.655 480.383 609.225 480.383C655.794 480.383 693.68 442.541 693.68 396.02C693.68 349.5 655.794 311.672 609.225 311.672ZM520.502 396.02C520.502 347.159 560.298 307.408 609.225 307.408C658.152 307.408 697.947 347.159 697.947 396.02C697.947 444.882 658.152 484.648 609.225 484.648C560.298 484.648 520.502 444.882 520.502 396.02Z",
    fill: "url(#paint33_linear_2109_83633)"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M609.225 311.806C562.73 311.806 524.919 349.574 524.919 396.005C524.919 442.436 562.744 480.219 609.225 480.219C655.705 480.219 693.545 442.436 693.545 396.005C693.545 349.574 655.719 311.806 609.225 311.806ZM520.815 396.02C520.815 347.338 560.476 307.721 609.225 307.721C657.973 307.721 697.634 347.323 697.634 396.02C697.634 444.718 657.973 484.335 609.225 484.335C560.476 484.335 520.815 444.718 520.815 396.02Z",
    fill: "url(#paint34_linear_2109_83633)"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M609.225 311.956C562.804 311.956 525.053 349.664 525.053 396.02C525.053 442.377 562.819 480.1 609.225 480.1C655.63 480.1 693.396 442.377 693.396 396.02C693.396 349.664 655.63 311.956 609.225 311.956ZM521.129 396.02C521.129 347.502 560.656 308.034 609.225 308.034C657.794 308.034 697.32 347.502 697.32 396.02C697.32 444.539 657.794 484.022 609.225 484.022C560.656 484.022 521.129 444.539 521.129 396.02Z",
    fill: "url(#paint35_linear_2109_83633)"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M609.225 312.09C562.879 312.09 525.187 349.738 525.187 396.005C525.187 442.272 562.894 479.951 609.225 479.951C655.555 479.951 693.262 442.302 693.262 396.005C693.262 349.709 655.555 312.09 609.225 312.09ZM521.442 396.02C521.442 347.681 560.82 308.362 609.225 308.362C657.629 308.362 697.007 347.681 697.007 396.02C697.007 444.36 657.629 483.708 609.225 483.708C560.82 483.708 521.442 444.375 521.442 396.02Z",
    fill: "url(#paint36_linear_2109_83633)"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M609.225 312.239C562.968 312.239 525.322 349.828 525.322 396.02C525.322 442.213 562.953 479.817 609.225 479.817C655.496 479.817 693.127 442.228 693.127 396.02C693.127 349.813 655.496 312.239 609.225 312.239ZM521.756 396.02C521.756 347.86 560.999 308.675 609.225 308.675C657.451 308.675 696.694 347.86 696.694 396.02C696.694 444.181 657.451 483.395 609.225 483.395C560.999 483.395 521.756 444.196 521.756 396.02Z",
    fill: "url(#paint37_linear_2109_83633)"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M609.225 312.373C563.043 312.373 525.456 349.888 525.456 396.005C525.456 442.123 563.028 479.668 609.225 479.668C655.421 479.668 692.978 442.138 692.978 396.005C692.978 349.873 655.406 312.373 609.225 312.373ZM522.069 396.02C522.069 348.024 561.163 308.988 609.225 308.988C657.286 308.988 696.38 348.024 696.38 396.02C696.38 444.017 657.286 483.067 609.225 483.067C561.163 483.067 522.069 444.017 522.069 396.02Z",
    fill: "url(#paint38_linear_2109_83633)"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M692.844 396.02C692.844 349.977 655.332 312.522 609.225 312.522C563.118 312.522 525.59 349.977 525.59 396.02C525.59 442.064 563.103 479.533 609.225 479.533C655.347 479.533 692.844 442.064 692.844 396.02ZM522.382 396.02C522.382 348.203 561.342 309.301 609.24 309.301C657.137 309.301 696.082 348.203 696.082 396.02C696.082 443.838 657.122 482.754 609.24 482.754C561.357 482.754 522.382 443.838 522.382 396.02Z",
    fill: "url(#paint39_linear_2109_83633)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M583.455 381.423H545.361V374.997H583.455V381.423ZM573.175 356.299C574.607 356.299 575.905 356.523 577.039 356.97C578.173 357.417 579.128 358.029 579.904 358.804C580.68 359.579 581.277 360.489 581.695 361.518C582.112 362.547 582.321 363.65 582.321 364.798C582.321 365.946 582.112 367.035 581.695 368.078C581.277 369.107 580.68 370.017 579.904 370.792C579.128 371.567 578.173 372.179 577.039 372.626C575.905 373.073 574.607 373.297 573.175 373.297H555.642C554.195 373.297 552.911 373.073 551.777 372.626C550.643 372.179 549.688 371.567 548.912 370.792C548.136 370.017 547.54 369.107 547.122 368.078C546.704 367.049 546.495 365.946 546.495 364.798C546.495 363.65 546.704 362.561 547.122 361.518C547.54 360.489 548.136 359.579 548.912 358.804C549.688 358.029 550.643 357.417 551.777 356.97C552.911 356.523 554.195 356.299 555.642 356.299H573.175ZM581.65 394.842H547.361V383.197H555.821V388.416H581.65V394.842ZM571.369 366.96C572.085 366.96 572.682 366.766 573.16 366.349C573.637 365.946 573.876 365.424 573.876 364.798C573.876 364.172 573.637 363.65 573.16 363.247C572.682 362.845 572.085 362.651 571.369 362.651H557.462C556.746 362.651 556.149 362.86 555.672 363.247C555.194 363.65 554.956 364.172 554.956 364.798C554.956 365.424 555.194 365.946 555.672 366.349C556.149 366.751 556.746 366.96 557.462 366.96H571.369Z",
    fill: "#606060"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M607.344 377.099C605.852 376.1 604.375 375.056 602.913 373.998C601.451 372.939 600.048 371.746 598.705 370.419C597.317 371.687 595.885 372.865 594.408 373.953C592.93 375.041 591.334 376.16 589.633 377.278L584.798 371.537C586.41 370.33 587.917 369.167 589.305 368.048C590.707 366.93 592.005 365.722 593.214 364.425C593.617 364.023 593.87 363.635 593.99 363.262C594.109 362.889 594.169 362.397 594.169 361.801V356.746H603.241V361.756C603.241 362.308 603.301 362.785 603.42 363.173C603.54 363.575 603.778 363.978 604.151 364.38C605.33 365.648 606.584 366.841 607.912 367.989C609.24 369.122 610.642 370.3 612.149 371.508L607.359 377.114L607.344 377.099ZM614.417 378.262C615.909 378.262 617.208 378.486 618.297 378.948C619.386 379.41 620.296 380.036 620.998 380.827C621.699 381.617 622.236 382.541 622.579 383.585C622.922 384.629 623.101 385.732 623.101 386.88C623.101 388.028 622.922 389.132 622.564 390.175C622.206 391.219 621.669 392.144 620.953 392.934C620.237 393.724 619.311 394.35 618.207 394.813C617.103 395.275 615.79 395.498 614.298 395.498H596.512C595.019 395.498 593.721 395.275 592.647 394.813C591.573 394.35 590.677 393.724 589.991 392.934C589.305 392.144 588.782 391.219 588.454 390.175C588.126 389.132 587.962 388.028 587.962 386.88C587.962 385.732 588.141 384.629 588.484 383.585C588.827 382.541 589.349 381.617 590.066 380.827C590.767 380.036 591.677 379.41 592.766 378.948C593.856 378.486 595.154 378.262 596.646 378.262H614.432H614.417ZM612.477 388.491C613.134 388.491 613.671 388.342 614.059 388.058C614.447 387.775 614.641 387.387 614.641 386.895C614.641 386.403 614.447 386.015 614.074 385.702C613.701 385.404 613.164 385.255 612.477 385.255H598.571C597.884 385.255 597.347 385.404 596.974 385.702C596.601 386.001 596.407 386.403 596.407 386.895C596.407 387.387 596.601 387.775 596.989 388.058C597.377 388.342 597.899 388.491 598.571 388.491H612.477ZM621.639 377.278H613.179V356.731H621.639V362.681H625.877V369.927H621.639V377.263V377.278Z",
    fill: "#606060"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M568.996 431.716H551.956V423.679C551.956 422.695 552.106 421.95 552.389 421.428C552.673 420.906 553.21 420.533 554.015 420.309L564.938 418.162C565.266 418.088 565.43 417.819 565.43 417.402V410.916C565.43 410.588 565.266 410.424 564.938 410.424H555.91C555.582 410.424 555.418 410.588 555.418 410.916V415.628H552.24V410.424C552.24 409.589 552.493 408.918 553.016 408.396C553.538 407.874 554.209 407.621 555.045 407.621H565.788C566.624 407.621 567.295 407.874 567.818 408.396C568.34 408.918 568.594 409.589 568.594 410.424V417.238C568.594 418.222 568.429 418.982 568.116 419.519C567.803 420.056 567.251 420.444 566.475 420.667L555.612 422.74C555.284 422.814 555.12 423.068 555.12 423.47V428.883H568.982V431.701L568.996 431.716Z",
    fill: "#606060"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M589.573 428.913C589.573 429.748 589.319 430.434 588.797 430.941C588.275 431.462 587.603 431.716 586.768 431.716H575.577C574.741 431.716 574.07 431.462 573.547 430.941C573.025 430.419 572.771 429.748 572.771 428.913V410.454C572.771 409.619 573.025 408.948 573.547 408.426C574.07 407.904 574.741 407.651 575.577 407.651H586.768C587.603 407.651 588.275 407.904 588.797 408.426C589.319 408.948 589.573 409.619 589.573 410.454V428.913ZM585.902 428.913C586.231 428.913 586.395 428.749 586.395 428.421V410.931C586.395 410.603 586.231 410.439 585.902 410.439H576.412C576.084 410.439 575.92 410.603 575.92 410.931V428.421C575.92 428.749 576.084 428.913 576.412 428.913H585.902Z",
    fill: "#606060"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M610.209 428.913C610.209 429.748 609.956 430.434 609.433 430.941C608.911 431.462 608.24 431.716 607.404 431.716H596.213C595.378 431.716 594.706 431.462 594.184 430.941C593.662 430.419 593.408 429.748 593.408 428.913V410.454C593.408 409.619 593.662 408.948 594.184 408.426C594.706 407.904 595.378 407.651 596.213 407.651H607.404C608.24 407.651 608.911 407.904 609.433 408.426C609.956 408.948 610.209 409.619 610.209 410.454V428.913ZM606.539 428.913C606.867 428.913 607.031 428.749 607.031 428.421V410.931C607.031 410.603 606.867 410.439 606.539 410.439H597.049C596.721 410.439 596.556 410.603 596.556 410.931V428.421C596.556 428.749 596.721 428.913 597.049 428.913H606.539Z",
    fill: "#606060"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M628.622 421.323H613.76V407.591H628.622V421.323ZM636.844 433.252H616.193V424.141H619.371V430.434H636.844V433.252ZM625.444 418.52V410.424H616.939V418.52H625.444ZM636.202 426.244H633.024V406.741H636.202V413.615H639.783V416.492H636.202V426.244Z",
    fill: "#606060"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M660.464 421.055H652.258V425.767H649.079V421.055H641.798V418.237H660.464V421.055ZM658.942 413.958C658.614 414.569 658.107 415.106 657.421 415.568C656.734 416.03 655.869 416.388 654.839 416.641C653.81 416.895 652.616 417.029 651.243 417.029C649.87 417.029 648.647 416.91 647.632 416.641C646.617 416.373 645.752 416.03 645.066 415.568C644.379 415.106 643.857 414.569 643.514 413.943C643.171 413.316 643.006 412.645 643.006 411.915C643.006 411.184 643.171 410.498 643.514 409.887C643.857 409.261 644.364 408.724 645.066 408.262C645.752 407.8 646.617 407.442 647.632 407.173C648.647 406.905 649.855 406.771 651.243 406.771C652.631 406.771 653.81 406.905 654.839 407.173C655.869 407.442 656.734 407.8 657.421 408.262C658.107 408.724 658.629 409.261 658.972 409.887C659.316 410.513 659.48 411.184 659.48 411.915C659.48 412.645 659.301 413.331 658.957 413.958H658.942ZM666.433 433.252H644.857V425.603H648.035V430.583H666.418V433.237L666.433 433.252ZM655.018 413.585C655.854 413.123 656.272 412.556 656.272 411.9C656.272 411.244 655.854 410.677 655.018 410.2C654.183 409.723 652.914 409.484 651.228 409.484C649.542 409.484 648.274 409.723 647.438 410.2C646.603 410.677 646.185 411.244 646.185 411.9C646.185 412.556 646.603 413.108 647.438 413.585C648.274 414.047 649.542 414.286 651.228 414.286C652.914 414.286 654.183 414.047 655.018 413.585ZM665.791 427.78H662.613V425.603H655.884V422.919H662.613V406.741H665.791V427.78Z",
    fill: "#606060"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M642.126 394.097H639.321L635.949 389.579L632.606 394.097H629.801L634.621 387.79L630.144 382.228H632.949L635.964 386.001L638.993 382.228H641.798L637.292 387.79L642.126 394.097Z",
    fill: "#606060"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M656.301 394.097H643.708V388.148C643.708 387.432 643.812 386.865 644.021 386.493C644.23 386.105 644.633 385.837 645.215 385.672L653.287 384.092C653.526 384.032 653.645 383.839 653.645 383.525V378.739C653.645 378.501 653.526 378.381 653.287 378.381H646.617C646.379 378.381 646.259 378.501 646.259 378.739V382.213H643.902V378.366C643.902 377.755 644.096 377.248 644.484 376.86C644.872 376.473 645.364 376.279 645.991 376.279H653.929C654.541 376.279 655.048 376.473 655.436 376.86C655.824 377.248 656.018 377.74 656.018 378.366V383.406C656.018 384.122 655.899 384.688 655.675 385.091C655.436 385.494 655.033 385.777 654.466 385.941L646.438 387.477C646.2 387.536 646.08 387.715 646.08 388.013V392.009H656.331V394.082L656.301 394.097Z",
    fill: "#606060"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M672.237 386.03H659.33V376.04H670.79V378.113H661.673V380.007H670.566V382.019H661.673V383.943H672.237V386.015V386.03ZM676.296 395.215H661.151V387.76H676.296V395.215ZM673.938 393.217V389.743H663.493V393.217H673.938ZM676.296 387.029H673.938V375.638H676.296V387.029Z",
    fill: "#606060"
  }))), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M825.301 480.339C871.903 480.339 909.681 442.588 909.681 396.02C909.681 349.453 871.903 311.702 825.301 311.702C778.699 311.702 740.92 349.453 740.92 396.02C740.92 442.588 778.699 480.339 825.301 480.339Z",
    fill: "url(#paint40_radial_2109_83633)"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M825.301 310.256C777.985 310.256 739.488 348.725 739.488 396.005C739.488 443.286 777.985 481.785 825.301 481.785C872.616 481.785 911.143 443.301 911.143 396.005C911.143 348.71 872.631 310.256 825.301 310.256ZM825.301 487.794C774.658 487.794 733.46 446.626 733.46 396.005C733.46 345.385 774.658 304.247 825.301 304.247C875.944 304.247 917.157 345.414 917.157 396.005C917.157 446.596 875.944 487.794 825.301 487.794Z",
    fill: "url(#paint41_linear_2109_83633)"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M825.301 310.405C778.06 310.405 739.622 348.814 739.622 396.02C739.622 443.227 778.06 481.651 825.301 481.651C872.542 481.651 910.994 443.242 910.994 396.02C910.994 348.799 872.557 310.405 825.301 310.405ZM733.773 396.005C733.773 345.578 774.837 304.56 825.301 304.56C875.765 304.56 916.843 345.578 916.843 396.005C916.843 446.432 875.78 487.481 825.301 487.481C774.822 487.481 733.773 446.447 733.773 396.005Z",
    fill: "url(#paint42_linear_2109_83633)"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M825.301 310.539C778.134 310.539 739.757 348.874 739.757 396.005C739.757 443.137 778.134 481.502 825.301 481.502C872.467 481.502 910.86 443.152 910.86 396.005C910.86 348.859 872.482 310.539 825.301 310.539ZM734.086 396.005C734.086 345.757 775.001 304.873 825.301 304.873C875.601 304.873 916.53 345.757 916.53 396.005C916.53 446.253 875.601 487.168 825.301 487.168C775.001 487.168 734.086 446.268 734.086 396.005Z",
    fill: "url(#paint43_linear_2109_83633)"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M825.301 310.688C778.209 310.688 739.891 348.963 739.891 396.02C739.891 443.078 778.209 481.367 825.301 481.367C872.392 481.367 910.725 443.078 910.725 396.02C910.725 348.963 872.407 310.688 825.301 310.688ZM734.4 396.005C734.4 345.921 775.18 305.186 825.301 305.186C875.421 305.186 916.217 345.921 916.217 396.005C916.217 446.089 875.436 486.84 825.301 486.84C775.165 486.84 734.4 446.089 734.4 396.005Z",
    fill: "url(#paint44_linear_2109_83633)"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M825.301 310.822C778.283 310.822 740.025 349.038 740.025 396.005C740.025 442.973 778.283 481.218 825.301 481.218C872.318 481.218 910.591 442.988 910.591 396.005C910.591 349.023 872.333 310.822 825.301 310.822ZM734.713 396.005C734.713 346.1 775.359 305.499 825.301 305.499C875.242 305.499 915.903 346.1 915.903 396.005C915.903 445.911 875.257 486.526 825.301 486.526C775.344 486.526 734.713 445.911 734.713 396.005Z",
    fill: "url(#paint45_linear_2109_83633)"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M825.301 310.971C778.358 310.971 740.174 349.127 740.174 396.02C740.174 442.914 778.358 481.084 825.301 481.084C872.243 481.084 910.442 442.928 910.442 396.02C910.442 349.112 872.243 310.971 825.301 310.971ZM735.026 396.005C735.026 346.279 775.523 305.812 825.301 305.812C875.078 305.812 915.59 346.264 915.59 396.005C915.59 445.746 875.078 486.213 825.301 486.213C775.523 486.213 735.026 445.746 735.026 396.005Z",
    fill: "url(#paint46_linear_2109_83633)"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M825.301 311.106C778.433 311.106 740.309 349.187 740.309 396.005C740.309 442.824 778.433 480.935 825.301 480.935C872.169 480.935 910.308 442.839 910.308 396.005C910.308 349.172 872.169 311.106 825.301 311.106ZM735.34 396.005C735.34 346.443 775.702 306.141 825.301 306.141C874.899 306.141 915.277 346.458 915.277 396.005C915.277 445.553 874.914 485.9 825.301 485.9C775.687 485.9 735.34 445.568 735.34 396.005Z",
    fill: "url(#paint47_linear_2109_83633)"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M825.301 311.255C778.507 311.255 740.443 349.276 740.443 396.02C740.443 442.765 778.507 480.801 825.301 480.801C872.094 480.801 910.173 442.765 910.173 396.02C910.173 349.276 872.109 311.255 825.301 311.255ZM735.653 396.005C735.653 346.622 775.866 306.454 825.301 306.454C874.735 306.454 914.963 346.622 914.963 396.005C914.963 445.389 874.735 485.587 825.301 485.587C775.866 485.587 735.653 445.404 735.653 396.005Z",
    fill: "url(#paint48_linear_2109_83633)"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M825.301 311.389C778.582 311.389 740.577 349.351 740.577 396.005C740.577 442.66 778.582 480.652 825.301 480.652C872.02 480.652 910.024 442.675 910.024 396.005C910.024 349.336 872.02 311.389 825.301 311.389ZM735.967 396.005C735.967 346.801 776.045 306.767 825.316 306.767C874.586 306.767 914.665 346.801 914.665 396.005C914.665 445.21 874.586 485.274 825.316 485.274C776.045 485.274 735.967 445.225 735.967 396.005Z",
    fill: "url(#paint49_linear_2109_83633)"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M825.301 311.523C778.656 311.523 740.711 349.425 740.711 396.005C740.711 442.586 778.656 480.503 825.301 480.503C871.945 480.503 909.89 442.6 909.89 396.005C909.89 349.41 871.945 311.523 825.301 311.523ZM736.265 396.02C736.265 346.98 776.209 307.095 825.301 307.095C874.392 307.095 914.337 346.98 914.337 396.02C914.337 445.061 874.392 484.961 825.301 484.961C776.209 484.961 736.265 445.061 736.265 396.02Z",
    fill: "url(#paint50_linear_2109_83633)"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M825.301 311.672C778.731 311.672 740.846 349.5 740.846 396.02C740.846 442.541 778.731 480.383 825.301 480.383C871.87 480.383 909.756 442.541 909.756 396.02C909.756 349.5 871.87 311.672 825.301 311.672ZM736.578 396.02C736.578 347.159 776.374 307.408 825.301 307.408C874.228 307.408 914.023 347.159 914.023 396.02C914.023 444.882 874.228 484.648 825.301 484.648C776.374 484.648 736.578 444.882 736.578 396.02Z",
    fill: "url(#paint51_linear_2109_83633)"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M825.301 311.806C778.806 311.806 740.995 349.574 740.995 396.005C740.995 442.436 778.821 480.219 825.301 480.219C871.781 480.219 909.621 442.436 909.621 396.005C909.621 349.574 871.796 311.806 825.301 311.806ZM736.892 396.02C736.892 347.338 776.553 307.721 825.301 307.721C874.049 307.721 913.71 347.323 913.71 396.02C913.71 444.718 874.049 484.335 825.301 484.335C776.553 484.335 736.892 444.718 736.892 396.02Z",
    fill: "url(#paint52_linear_2109_83633)"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M825.301 311.956C778.88 311.956 741.129 349.664 741.129 396.02C741.129 442.377 778.895 480.1 825.301 480.1C871.706 480.1 909.472 442.377 909.472 396.02C909.472 349.664 871.706 311.956 825.301 311.956ZM737.205 396.02C737.205 347.502 776.732 308.034 825.301 308.034C873.87 308.034 913.397 347.502 913.397 396.02C913.397 444.539 873.87 484.022 825.301 484.022C776.732 484.022 737.205 444.539 737.205 396.02Z",
    fill: "url(#paint53_linear_2109_83633)"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M825.301 312.09C778.955 312.09 741.264 349.738 741.264 396.005C741.264 442.272 778.955 479.951 825.301 479.951C871.646 479.951 909.338 442.302 909.338 396.005C909.338 349.709 871.632 312.09 825.301 312.09ZM737.518 396.02C737.518 347.681 776.896 308.362 825.301 308.362C873.706 308.362 913.083 347.681 913.083 396.02C913.083 444.36 873.706 483.708 825.301 483.708C776.896 483.708 737.518 444.375 737.518 396.02Z",
    fill: "url(#paint54_linear_2109_83633)"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M825.301 312.239C779.045 312.239 741.398 349.828 741.398 396.02C741.398 442.213 779.03 479.817 825.301 479.817C871.572 479.817 909.204 442.228 909.204 396.02C909.204 349.813 871.572 312.239 825.301 312.239ZM737.832 396.02C737.832 347.86 777.075 308.675 825.301 308.675C873.527 308.675 912.77 347.86 912.77 396.02C912.77 444.181 873.527 483.395 825.301 483.395C777.075 483.395 737.832 444.196 737.832 396.02Z",
    fill: "url(#paint55_linear_2109_83633)"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M825.301 312.373C779.119 312.373 741.532 349.888 741.532 396.005C741.532 442.123 779.104 479.668 825.301 479.668C871.497 479.668 909.069 442.138 909.069 396.005C909.069 349.873 871.497 312.373 825.301 312.373ZM738.145 396.02C738.145 348.024 777.239 308.988 825.301 308.988C873.362 308.988 912.456 348.024 912.456 396.02C912.456 444.017 873.362 483.067 825.301 483.067C777.239 483.067 738.145 444.017 738.145 396.02Z",
    fill: "url(#paint56_linear_2109_83633)"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M908.935 396.02C908.935 349.977 871.423 312.522 825.316 312.522C779.209 312.522 741.682 349.977 741.682 396.02C741.682 442.064 779.194 479.533 825.316 479.533C871.438 479.533 908.935 442.064 908.935 396.02ZM738.458 396.02C738.458 348.203 777.418 309.301 825.316 309.301C873.213 309.301 912.158 348.203 912.158 396.02C912.158 443.838 873.198 482.754 825.316 482.754C777.433 482.754 738.458 443.838 738.458 396.02Z",
    fill: "url(#paint57_linear_2109_83633)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M798.174 379.738H760.079V373.699H774.284V371.493H762.064V356.866H796.174V362.904H770.524V365.454H796.652V371.493H783.954V373.699H798.159V379.738H798.174ZM788.669 380.991C790.161 380.991 791.459 381.184 792.533 381.572C793.608 381.96 794.503 382.482 795.204 383.153C795.906 383.809 796.443 384.599 796.786 385.479C797.129 386.373 797.308 387.313 797.308 388.282C797.308 389.251 797.129 390.19 796.771 391.07C796.413 391.95 795.876 392.71 795.145 393.381C794.428 394.037 793.518 394.574 792.429 394.962C791.34 395.349 790.041 395.543 788.549 395.543H769.584C768.092 395.543 766.809 395.349 765.735 394.962C764.675 394.574 763.795 394.052 763.093 393.381C762.407 392.725 761.885 391.95 761.557 391.07C761.228 390.19 761.064 389.266 761.064 388.282C761.064 387.298 761.243 386.373 761.586 385.479C761.93 384.584 762.452 383.809 763.168 383.153C763.869 382.497 764.765 381.96 765.839 381.572C766.913 381.184 768.212 380.991 769.704 380.991H788.669ZM786.774 389.355C787.43 389.355 787.967 389.266 788.355 389.072C788.743 388.878 788.937 388.625 788.937 388.267C788.937 387.521 788.221 387.149 786.774 387.149H771.658C770.226 387.149 769.495 387.521 769.495 388.267C769.495 388.61 769.689 388.878 770.077 389.072C770.465 389.251 770.987 389.355 771.658 389.355H786.774Z",
    fill: "#8E6545"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M822.048 377.099C820.555 376.1 819.078 375.056 817.616 373.998C816.154 372.939 814.766 371.746 813.408 370.419C812.021 371.687 810.588 372.865 809.111 373.953C807.634 375.041 806.037 376.16 804.336 377.278L799.501 371.537C801.113 370.33 802.62 369.167 804.008 368.048C805.41 366.93 806.709 365.722 807.917 364.425C808.32 364.023 808.574 363.635 808.693 363.262C808.812 362.889 808.872 362.397 808.872 361.801V356.746H817.944V361.756C817.944 362.308 818.004 362.785 818.123 363.173C818.243 363.575 818.481 363.978 818.855 364.38C820.033 365.648 821.287 366.841 822.615 367.989C823.943 369.122 825.345 370.3 826.852 371.508L822.063 377.114L822.048 377.099ZM829.135 378.262C830.627 378.262 831.926 378.486 833.015 378.948C834.104 379.41 835.014 380.036 835.716 380.827C836.417 381.617 836.954 382.541 837.297 383.585C837.64 384.629 837.82 385.732 837.82 386.88C837.82 388.028 837.64 389.132 837.282 390.175C836.924 391.219 836.387 392.144 835.671 392.934C834.955 393.724 834.03 394.35 832.925 394.813C831.821 395.275 830.508 395.498 829.016 395.498H811.23C809.737 395.498 808.439 395.275 807.365 394.813C806.291 394.35 805.395 393.724 804.709 392.934C804.023 392.144 803.5 391.219 803.172 390.175C802.844 389.132 802.68 388.028 802.68 386.88C802.68 385.732 802.859 384.629 803.202 383.585C803.545 382.541 804.067 381.617 804.784 380.827C805.485 380.036 806.395 379.41 807.484 378.948C808.574 378.486 809.872 378.262 811.364 378.262H829.15H829.135ZM827.181 388.491C827.837 388.491 828.374 388.342 828.762 388.058C829.15 387.775 829.344 387.387 829.344 386.895C829.344 386.403 829.15 386.015 828.777 385.702C828.404 385.404 827.867 385.255 827.181 385.255H813.274C812.587 385.255 812.05 385.404 811.677 385.702C811.304 386.001 811.11 386.403 811.11 386.895C811.11 387.387 811.304 387.775 811.692 388.058C812.08 388.342 812.602 388.491 813.274 388.491H827.181ZM836.342 377.278H827.882V356.731H836.342V362.681H840.58V369.927H836.342V377.263V377.278Z",
    fill: "#8E6545"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M777.955 431.716H774.777V410.439H770.868V407.621H777.97V431.716H777.955Z",
    fill: "#8E6545"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M799.114 428.913C799.114 429.748 798.86 430.434 798.338 430.941C797.816 431.462 797.144 431.716 796.309 431.716H785.117C784.282 431.716 783.61 431.462 783.088 430.941C782.566 430.419 782.312 429.748 782.312 428.913V410.454C782.312 409.619 782.566 408.948 783.088 408.426C783.61 407.904 784.282 407.651 785.117 407.651H796.309C797.144 407.651 797.816 407.904 798.338 408.426C798.86 408.948 799.114 409.619 799.114 410.454V428.913ZM795.443 428.913C795.771 428.913 795.935 428.749 795.935 428.421V410.931C795.935 410.603 795.771 410.439 795.443 410.439H785.953C785.625 410.439 785.461 410.603 785.461 410.931V428.421C785.461 428.749 785.625 428.913 785.953 428.913H795.443Z",
    fill: "#8E6545"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M819.735 428.913C819.735 429.748 819.481 430.434 818.959 430.941C818.437 431.462 817.765 431.716 816.93 431.716H805.739C804.903 431.716 804.232 431.462 803.71 430.941C803.187 430.419 802.934 429.748 802.934 428.913V410.454C802.934 409.619 803.187 408.948 803.71 408.426C804.232 407.904 804.903 407.651 805.739 407.651H816.93C817.765 407.651 818.437 407.904 818.959 408.426C819.481 408.948 819.735 409.619 819.735 410.454V428.913ZM816.064 428.913C816.393 428.913 816.557 428.749 816.557 428.421V410.931C816.557 410.603 816.393 410.439 816.064 410.439H806.574C806.246 410.439 806.082 410.603 806.082 410.931V428.421C806.082 428.749 806.246 428.913 806.574 428.913H816.064Z",
    fill: "#8E6545"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M838.163 421.323H823.301V407.591H838.163V421.323ZM846.385 433.252H825.733V424.141H828.912V430.434H846.385V433.252ZM834.985 418.52V410.424H826.48V418.52H834.985ZM845.743 426.244H842.565V406.741H845.743V413.615H849.324V416.492H845.743V426.244Z",
    fill: "#8E6545"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M870.005 421.055H861.799V425.767H858.62V421.055H851.339V418.237H870.005V421.055ZM868.483 413.958C868.155 414.569 867.648 415.106 866.961 415.568C866.275 416.03 865.409 416.388 864.38 416.641C863.35 416.895 862.157 417.029 860.784 417.029C859.411 417.029 858.188 416.91 857.173 416.641C856.158 416.388 855.293 416.03 854.606 415.568C853.92 415.106 853.398 414.569 853.055 413.943C852.711 413.316 852.547 412.645 852.547 411.915C852.547 411.184 852.711 410.498 853.055 409.887C853.398 409.261 853.905 408.724 854.606 408.262C855.293 407.8 856.158 407.442 857.173 407.173C858.188 406.905 859.396 406.771 860.784 406.771C862.172 406.771 863.35 406.905 864.38 407.173C865.409 407.442 866.275 407.8 866.961 408.262C867.648 408.724 868.17 409.261 868.513 409.887C868.856 410.513 869.02 411.184 869.02 411.915C869.02 412.645 868.841 413.331 868.498 413.958H868.483ZM875.974 433.252H854.397V425.603H857.576V430.583H875.959V433.237L875.974 433.252ZM864.559 413.585C865.395 413.123 865.812 412.556 865.812 411.9C865.812 411.244 865.395 410.677 864.559 410.2C863.723 409.723 862.455 409.484 860.769 409.484C859.083 409.484 857.815 409.723 856.979 410.2C856.143 410.677 855.726 411.244 855.726 411.9C855.726 412.556 856.143 413.108 856.979 413.585C857.815 414.047 859.083 414.286 860.769 414.286C862.455 414.286 863.723 414.047 864.559 413.585ZM875.332 427.78H872.154V425.603H865.424V422.919H872.154V406.741H875.332V427.78Z",
    fill: "#8E6545"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M856.829 394.097H854.024L850.652 389.579L847.31 394.097H844.504L849.324 387.79L844.848 382.228H847.653L850.667 386.001L853.696 382.228H856.501L851.995 387.79L856.829 394.097Z",
    fill: "#8E6545"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M871.005 394.097H858.411V388.148C858.411 387.432 858.516 386.865 858.725 386.493C858.933 386.105 859.336 385.837 859.918 385.672L867.991 384.092C868.229 384.032 868.349 383.839 868.349 383.525V378.739C868.349 378.501 868.229 378.381 867.991 378.381H861.321C861.082 378.381 860.963 378.501 860.963 378.739V382.213H858.605V378.366C858.605 377.755 858.799 377.248 859.187 376.86C859.575 376.473 860.067 376.279 860.694 376.279H868.632C869.244 376.279 869.751 376.473 870.139 376.86C870.527 377.248 870.721 377.74 870.721 378.366V383.406C870.721 384.122 870.602 384.688 870.378 385.091C870.139 385.494 869.736 385.777 869.169 385.941L861.142 387.477C860.903 387.536 860.784 387.715 860.784 388.013V392.009H871.035V394.082L871.005 394.097Z",
    fill: "#8E6545"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M886.956 386.03H874.049V376.04H885.508V378.113H876.391V380.007H885.285V382.019H876.391V383.943H886.956V386.015V386.03ZM890.999 395.215H875.854V387.76H890.999V395.215ZM888.642 393.217V389.743H878.197V393.217H888.642ZM890.999 387.029H888.642V375.638H890.999V387.029Z",
    fill: "#8E6545"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2109_83633)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M176.624 488.674C227.586 488.674 268.898 447.392 268.898 396.468C268.898 345.544 227.586 304.262 176.624 304.262C125.663 304.262 84.3506 345.544 84.3506 396.468C84.3506 447.392 125.663 488.674 176.624 488.674Z",
    fill: "url(#paint58_linear_2109_83633)",
    stroke: "white",
    strokeMiterlimit: 10
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_2109_83633)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M174.64 394.842H166.687V377.755H164.747V394.499H156.883V387.805L153.168 391.517H137.575V357.596H154.854V364.843H145.14V384.181H156.883V356.866H164.747V370.032H166.687V356.746H174.64V394.842Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.036 377.099C197.544 376.1 196.067 375.056 194.605 373.998C193.157 372.939 191.755 371.746 190.397 370.419C189.009 371.687 187.577 372.865 186.1 373.953C184.622 375.041 183.026 376.16 181.325 377.278L176.49 371.537C178.102 370.33 179.609 369.167 180.996 368.048C182.399 366.93 183.697 365.722 184.906 364.425C185.309 364.023 185.562 363.635 185.682 363.262C185.801 362.889 185.861 362.397 185.861 361.801V356.746H194.933V361.756C194.933 362.308 194.993 362.785 195.112 363.173C195.231 363.575 195.47 363.978 195.843 364.38C197.022 365.648 198.275 366.841 199.603 367.989C200.931 369.122 202.334 370.3 203.841 371.508L199.051 377.114L199.036 377.099ZM206.124 378.262C207.616 378.262 208.914 378.486 210.004 378.948C211.093 379.41 212.003 380.036 212.704 380.827C213.406 381.617 213.928 382.541 214.286 383.585C214.629 384.629 214.808 385.732 214.808 386.88C214.808 388.028 214.629 389.132 214.271 390.175C213.913 391.219 213.376 392.144 212.645 392.934C211.928 393.724 211.003 394.35 209.899 394.813C208.795 395.275 207.482 395.498 205.99 395.498H188.204C186.711 395.498 185.413 395.275 184.339 394.813C183.265 394.35 182.369 393.724 181.683 392.934C180.996 392.144 180.474 391.219 180.146 390.175C179.818 389.132 179.654 388.028 179.654 386.88C179.654 385.732 179.833 384.629 180.176 383.585C180.519 382.541 181.041 381.617 181.757 380.827C182.459 380.036 183.369 379.41 184.458 378.948C185.548 378.486 186.846 378.262 188.338 378.262H206.124ZM204.184 388.491C204.841 388.491 205.378 388.342 205.766 388.058C206.154 387.775 206.348 387.387 206.348 386.895C206.348 386.403 206.154 386.015 205.781 385.702C205.408 385.404 204.871 385.255 204.184 385.255H190.278C189.591 385.255 189.054 385.404 188.681 385.702C188.308 386.001 188.114 386.403 188.114 386.895C188.114 387.387 188.308 387.775 188.696 388.058C189.084 388.342 189.606 388.491 190.278 388.491H204.184ZM213.331 377.278H204.871V356.731H213.331V362.681H217.569V369.927H213.331V377.263V377.278Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_2109_83633)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M116.999 431.716H113.821V410.439H109.911V407.621H117.014V431.716H116.999Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.505 436.8H119.908L121.132 429.151H125.011L122.505 436.8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.842 428.913C144.842 429.748 144.588 430.434 144.066 430.941C143.544 431.462 142.872 431.716 142.037 431.716H130.846C130.01 431.716 129.324 431.462 128.816 430.941C128.294 430.419 128.041 429.748 128.041 428.913V410.454C128.041 409.619 128.294 408.948 128.816 408.426C129.339 407.904 130.01 407.651 130.846 407.651H142.037C142.872 407.651 143.544 407.904 144.066 408.426C144.588 408.948 144.842 409.619 144.842 410.454V428.913ZM141.171 428.913C141.5 428.913 141.664 428.749 141.664 428.421V410.931C141.664 410.603 141.5 410.439 141.171 410.439H131.681C131.353 410.439 131.189 410.603 131.189 410.931V428.421C131.189 428.749 131.353 428.913 131.681 428.913H141.171Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.464 428.913C165.464 429.748 165.21 430.434 164.688 430.941C164.165 431.462 163.494 431.716 162.658 431.716H151.467C150.632 431.716 149.945 431.462 149.438 430.941C148.916 430.419 148.662 429.748 148.662 428.913V410.454C148.662 409.619 148.916 408.948 149.438 408.426C149.96 407.904 150.632 407.651 151.467 407.651H162.658C163.494 407.651 164.165 407.904 164.688 408.426C165.21 408.948 165.464 409.619 165.464 410.454V428.913ZM161.793 428.913C162.121 428.913 162.285 428.749 162.285 428.421V410.931C162.285 410.603 162.121 410.439 161.793 410.439H152.303C151.975 410.439 151.811 410.603 151.811 410.931V428.421C151.811 428.749 151.975 428.913 152.303 428.913H161.793Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.085 428.913C186.085 429.748 185.831 430.434 185.309 430.941C184.787 431.462 184.115 431.716 183.279 431.716H172.088C171.253 431.716 170.566 431.462 170.059 430.941C169.537 430.419 169.283 429.748 169.283 428.913V410.454C169.283 409.619 169.537 408.948 170.059 408.426C170.581 407.904 171.253 407.651 172.088 407.651H183.279C184.115 407.651 184.787 407.904 185.309 408.426C185.831 408.948 186.085 409.619 186.085 410.454V428.913ZM182.414 428.913C182.742 428.913 182.906 428.749 182.906 428.421V410.931C182.906 410.603 182.742 410.439 182.414 410.439H172.924C172.596 410.439 172.432 410.603 172.432 410.931V428.421C172.432 428.749 172.596 428.913 172.924 428.913H182.414Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.497 421.323H189.636V407.591H204.497V421.323ZM212.719 433.252H192.068V424.141H195.246V430.434H212.719V433.252ZM201.319 418.52V410.424H192.814V418.52H201.319ZM212.077 426.244H208.899V406.741H212.077V413.615H215.659V416.492H212.077V426.244Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.34 421.055H228.148V425.767H224.97V421.055H217.688V418.237H236.355V421.055H236.34ZM234.818 413.958C234.489 414.569 233.982 415.106 233.281 415.568C232.594 416.03 231.729 416.388 230.699 416.641C229.67 416.895 228.476 417.029 227.103 417.029C225.731 417.029 224.507 416.91 223.492 416.641C222.478 416.388 221.612 416.03 220.926 415.568C220.24 415.106 219.717 414.569 219.374 413.943C219.031 413.316 218.867 412.645 218.867 411.915C218.867 411.184 219.031 410.498 219.374 409.887C219.717 409.261 220.225 408.724 220.926 408.262C221.612 407.8 222.478 407.442 223.492 407.173C224.507 406.905 225.716 406.771 227.103 406.771C228.491 406.771 229.67 406.905 230.699 407.173C231.729 407.442 232.594 407.8 233.281 408.262C233.967 408.724 234.489 409.261 234.833 409.887C235.176 410.513 235.34 411.184 235.34 411.915C235.34 412.645 235.161 413.331 234.818 413.958ZM242.308 433.252H220.732V425.603H223.91V430.583H242.293V433.237L242.308 433.252ZM230.893 413.585C231.729 413.123 232.147 412.556 232.147 411.9C232.147 411.244 231.729 410.677 230.893 410.2C230.058 409.723 228.789 409.484 227.103 409.484C225.417 409.484 224.149 409.723 223.313 410.2C222.478 410.677 222.06 411.244 222.06 411.9C222.06 412.556 222.478 413.108 223.313 413.585C224.149 414.047 225.417 414.286 227.103 414.286C228.789 414.286 230.058 414.047 230.893 413.585ZM241.667 427.78H238.488V425.603H231.759V422.919H238.488V406.741H241.667V427.78Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M260.258 396.02C260.258 349.977 222.746 312.522 176.639 312.522C130.532 312.522 93.0048 349.977 93.0048 396.02C93.0048 442.064 130.517 479.533 176.639 479.533C222.761 479.533 260.258 442.064 260.258 396.02ZM89.7817 396.02C89.7817 348.203 128.741 309.301 176.639 309.301C224.537 309.301 263.481 348.203 263.481 396.02C263.481 443.838 224.522 482.754 176.639 482.754C128.756 482.754 89.7817 443.838 89.7817 396.02Z",
    fill: "url(#paint59_linear_2109_83633)",
    style: {
      mixBlendMode: "screen"
    }
  }), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M993.569 537.252C990.555 537.252 988.063 539.339 987.377 542.142H14.1158C13.4444 539.339 10.9376 537.252 7.92345 537.252C4.40201 537.252 1.53711 540.1 1.53711 543.633C1.53711 547.167 4.38709 550.015 7.92345 550.015C10.9376 550.015 13.4294 547.928 14.1158 545.124H987.377C988.048 547.928 990.555 550.015 993.569 550.015C997.091 550.015 999.955 547.167 999.955 543.633C999.955 540.1 997.105 537.252 993.569 537.252Z",
    fill: "url(#paint60_linear_2109_83633)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2109_83633",
    x: 73.8506,
    y: 293.762,
    width: 205.547,
    height: 205.412,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.756863 0 0 0 0 0.580392 0 0 0 0 0.764706 0 0 0 0.75 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2109_83633"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2109_83633",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_2109_83633",
    x: 131.915,
    y: 351.071,
    width: 91.3137,
    height: 50.0871,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.83
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.756863 0 0 0 0 0.580392 0 0 0 0 0.764706 0 0 0 0.75 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2109_83633"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2109_83633",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_2109_83633",
    x: 104.251,
    y: 401.081,
    width: 143.717,
    height: 41.3793,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.83
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.756863 0 0 0 0 0.580392 0 0 0 0 0.764706 0 0 0 0.75 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2109_83633"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2109_83633",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2109_83633",
    x1: 684.935,
    y1: 51.1427,
    x2: 543.219,
    y2: 296.777,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#DDDEE4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#37383A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#C8C9CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#A2A3A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#7C7D7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#5D5E61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#48494B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#3B3C3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#37383A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#C8C9CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#37383A",
    stopOpacity: 0.79
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#DDDEE4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2109_83633",
    x1: 154.75,
    y1: 0.0149412,
    x2: 154.75,
    y2: 41.5255,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9A9CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#9688B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#8579B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#635F8E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#625D8E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#5C4F91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A4B93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2109_83633",
    x1: 500.746,
    y1: 0.0000307358,
    x2: 500.746,
    y2: 0.0000307358,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9A9CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#9688B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#8579B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#635F8E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#625D8E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#5C4F91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A4B93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2109_83633",
    x1: 848.608,
    y1: 0,
    x2: 848.608,
    y2: 93.6522,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9A9CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#9688B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#8579B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#635F8E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#625D8E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#5C4F91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A4B93"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_2109_83633",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(546.063 562.316) scale(352.98 352.72)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCA33E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#F7DE8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#D3AA41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#F3F4C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#F7DE8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#DCB951"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7DE8A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2109_83633",
    x1: 301.292,
    y1: 396.02,
    x2: 484.989,
    y2: 396.02,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB942E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#F3F4C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#D8C064"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#CCA33E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#F7DE8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#D3AA41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F3F4C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#F7DE8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#BB942E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#D8C064"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#CCA33E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F4C5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2109_83633",
    x1: 301.606,
    y1: 396.02,
    x2: 484.676,
    y2: 396.02,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB942E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#F3F4C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#D8C064"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#CCA33E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#F7DE8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#D3AA41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F3F4C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#F7DE8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#BB942E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#D8C064"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#CCA33E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F4C5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2109_83633",
    x1: 301.919,
    y1: 0.0000330958,
    x2: 484.362,
    y2: 0.0000330958,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB942E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#F3F4C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#D8C064"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#CCA33E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#F7DE8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#D3AA41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F3F4C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#F7DE8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#BB942E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#D8C064"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#CCA33E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F4C5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2109_83633",
    x1: 302.232,
    y1: 396.02,
    x2: 484.049,
    y2: 396.02,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB942E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#F3F4C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#D8C064"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#CCA33E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#F7DE8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#D3AA41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F3F4C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#F7DE8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#BB942E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#D8C064"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#CCA33E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F4C5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2109_83633",
    x1: 302.546,
    y1: 396.02,
    x2: 483.736,
    y2: 396.02,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB942E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#F3F4C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#D8C064"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#CCA33E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#F7DE8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#D3AA41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F3F4C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#F7DE8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#BB942E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#D8C064"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#CCA33E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F4C5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2109_83633",
    x1: 302.859,
    y1: 396.02,
    x2: 483.423,
    y2: 396.02,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB942E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#F3F4C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#D8C064"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#CCA33E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#F7DE8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#D3AA41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F3F4C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#F7DE8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#BB942E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#D8C064"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#CCA33E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F4C5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_2109_83633",
    x1: 303.172,
    y1: 396.02,
    x2: 483.109,
    y2: 396.02,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB942E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#F3F4C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#D8C064"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#CCA33E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#F7DE8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#D3AA41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F3F4C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#F7DE8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#BB942E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#D8C064"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#CCA33E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F4C5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_2109_83633",
    x1: 303.486,
    y1: 0.0000694033,
    x2: 482.811,
    y2: 0.0000694033,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB942E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#F3F4C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#D8C064"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#CCA33E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#F7DE8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#D3AA41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F3F4C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#F7DE8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#BB942E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#D8C064"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#CCA33E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F4C5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_2109_83633",
    x1: 303.799,
    y1: 396.02,
    x2: 482.498,
    y2: 396.02,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB942E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#F3F4C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#D8C064"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#CCA33E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#F7DE8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#D3AA41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F3F4C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#F7DE8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#BB942E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#D8C064"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#CCA33E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F4C5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_2109_83633",
    x1: 304.113,
    y1: 396.02,
    x2: 482.184,
    y2: 396.02,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB942E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#F3F4C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#D8C064"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#CCA33E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#F7DE8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#D3AA41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F3F4C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#F7DE8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#BB942E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#D8C064"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#CCA33E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F4C5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_2109_83633",
    x1: 304.426,
    y1: 0.0000709077,
    x2: 481.871,
    y2: 0.0000709077,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB942E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#F3F4C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#D8C064"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#CCA33E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#F7DE8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#D3AA41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F3F4C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#F7DE8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#BB942E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#D8C064"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#CCA33E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F4C5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_2109_83633",
    x1: 304.739,
    y1: 396.02,
    x2: 481.557,
    y2: 396.02,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB942E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#F3F4C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#D8C064"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#CCA33E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#F7DE8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#D3AA41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F3F4C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#F7DE8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#BB942E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#D8C064"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#CCA33E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F4C5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_2109_83633",
    x1: 305.053,
    y1: 0.0000680413,
    x2: 481.244,
    y2: 0.0000680413,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB942E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#F3F4C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#D8C064"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#CCA33E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#F7DE8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#D3AA41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F3F4C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#F7DE8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#BB942E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#D8C064"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#CCA33E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F4C5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_2109_83633",
    x1: 305.351,
    y1: 396.02,
    x2: 480.931,
    y2: 396.02,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB942E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#F3F4C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#D8C064"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#CCA33E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#F7DE8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#D3AA41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F3F4C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#F7DE8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#BB942E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#D8C064"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#CCA33E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F4C5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_2109_83633",
    x1: 305.665,
    y1: 396.02,
    x2: 480.618,
    y2: 396.02,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB942E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#F3F4C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#D8C064"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#CCA33E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#F7DE8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#D3AA41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F3F4C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#F7DE8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#BB942E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#D8C064"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#CCA33E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F4C5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_2109_83633",
    x1: 305.978,
    y1: 396.02,
    x2: 480.304,
    y2: 396.02,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB942E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#F3F4C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#D8C064"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#CCA33E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#F7DE8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#D3AA41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F3F4C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#F7DE8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#BB942E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#D8C064"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#CCA33E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F4C5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_2109_83633",
    x1: 393.141,
    y1: 309.293,
    x2: 393.141,
    y2: 482.746,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB942E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#F3F4C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#D8C064"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#CCA33E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#F7DE8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#D3AA41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F3F4C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#F7DE8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#BB942E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#D8C064"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#CCA33E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F4C5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint22_radial_2109_83633",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(762.139 562.316) scale(352.98 352.72)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#868586"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#C3C3C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#8A8A8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E3E2E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#C3C3C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#979797"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C3C3C3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_2109_83633",
    x1: 517.384,
    y1: 396.02,
    x2: 701.066,
    y2: 396.02,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#757575"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#E3E2E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#A09F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#868586"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#C3C3C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#8A8A8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#E3E2E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#C3C3C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#757575"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#A09F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#868586"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E3E2E1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_2109_83633",
    x1: 517.697,
    y1: 396.02,
    x2: 700.752,
    y2: 396.02,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#757575"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#E3E2E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#A09F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#868586"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#C3C3C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#8A8A8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#E3E2E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#C3C3C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#757575"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#A09F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#868586"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E3E2E1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_2109_83633",
    x1: 518.01,
    y1: 0.0000174439,
    x2: 700.439,
    y2: 0.0000174439,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#757575"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#E3E2E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#A09F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#868586"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#C3C3C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#8A8A8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#E3E2E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#C3C3C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#757575"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#A09F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#868586"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E3E2E1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_2109_83633",
    x1: 518.323,
    y1: 396.02,
    x2: 700.14,
    y2: 396.02,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#757575"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#E3E2E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#A09F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#868586"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#C3C3C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#8A8A8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#E3E2E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#C3C3C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#757575"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#A09F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#868586"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E3E2E1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_2109_83633",
    x1: 518.622,
    y1: 396.02,
    x2: 699.827,
    y2: 396.02,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#757575"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#E3E2E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#A09F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#868586"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#C3C3C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#8A8A8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#E3E2E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#C3C3C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#757575"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#A09F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#868586"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E3E2E1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_2109_83633",
    x1: 518.935,
    y1: 396.02,
    x2: 699.514,
    y2: 396.02,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#757575"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#E3E2E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#A09F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#868586"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#C3C3C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#8A8A8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#E3E2E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#C3C3C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#757575"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#A09F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#868586"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E3E2E1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_2109_83633",
    x1: 519.249,
    y1: 396.02,
    x2: 699.2,
    y2: 396.02,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#757575"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#E3E2E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#A09F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#868586"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#C3C3C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#8A8A8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#E3E2E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#C3C3C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#757575"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#A09F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#868586"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E3E2E1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_2109_83633",
    x1: 519.562,
    y1: 0.0000694033,
    x2: 698.887,
    y2: 0.0000694033,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#757575"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#E3E2E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#A09F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#868586"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#C3C3C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#8A8A8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#E3E2E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#C3C3C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#757575"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#A09F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#868586"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E3E2E1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_2109_83633",
    x1: 519.875,
    y1: 396.02,
    x2: 698.574,
    y2: 396.02,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#757575"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#E3E2E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#A09F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#868586"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#C3C3C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#8A8A8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#E3E2E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#C3C3C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#757575"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#A09F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#868586"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E3E2E1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_2109_83633",
    x1: 520.189,
    y1: 396.02,
    x2: 698.26,
    y2: 396.02,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#757575"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#E3E2E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#A09F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#868586"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#C3C3C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#8A8A8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#E3E2E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#C3C3C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#757575"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#A09F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#868586"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E3E2E1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_2109_83633",
    x1: 520.502,
    y1: 0.0000709077,
    x2: 697.947,
    y2: 0.0000709077,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#757575"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#E3E2E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#A09F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#868586"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#C3C3C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#8A8A8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#E3E2E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#C3C3C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#757575"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#A09F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#868586"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E3E2E1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_2109_83633",
    x1: 520.815,
    y1: 396.02,
    x2: 697.634,
    y2: 396.02,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#757575"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#E3E2E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#A09F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#868586"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#C3C3C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#8A8A8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#E3E2E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#C3C3C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#757575"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#A09F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#868586"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E3E2E1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_2109_83633",
    x1: 521.129,
    y1: 0.0000680413,
    x2: 697.32,
    y2: 0.0000680413,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#757575"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#E3E2E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#A09F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#868586"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#C3C3C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#8A8A8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#E3E2E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#C3C3C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#757575"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#A09F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#868586"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E3E2E1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_2109_83633",
    x1: 521.442,
    y1: 396.02,
    x2: 697.007,
    y2: 396.02,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#757575"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#E3E2E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#A09F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#868586"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#C3C3C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#8A8A8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#E3E2E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#C3C3C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#757575"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#A09F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#868586"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E3E2E1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_2109_83633",
    x1: 521.756,
    y1: 396.02,
    x2: 696.694,
    y2: 396.02,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#757575"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#E3E2E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#A09F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#868586"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#C3C3C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#8A8A8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#E3E2E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#C3C3C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#757575"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#A09F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#868586"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E3E2E1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_2109_83633",
    x1: 522.069,
    y1: 396.02,
    x2: 696.38,
    y2: 396.02,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#757575"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#E3E2E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#A09F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#868586"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#C3C3C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#8A8A8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#E3E2E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#C3C3C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#757575"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#A09F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#868586"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E3E2E1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_2109_83633",
    x1: 609.233,
    y1: 309.293,
    x2: 609.233,
    y2: 482.746,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#757575"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#E3E2E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#A09F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#868586"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#C3C3C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#8A8A8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#E3E2E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#C3C3C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#757575"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#A09F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#868586"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E3E2E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint40_radial_2109_83633",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(978.215 562.316) scale(352.98 352.72)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#E29957"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FAF8D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#F7C189"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#E29957"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7C189"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_2109_83633",
    x1: 733.46,
    y1: 396.02,
    x2: 917.157,
    y2: 396.02,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BF6D28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#FBF2C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#DBA05F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#CD7C3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#F7C189"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#D5803B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FBF2C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#F7C189"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#BF6D28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#DBA05F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#CD7C3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBF2C4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_2109_83633",
    x1: 733.773,
    y1: 396.02,
    x2: 916.843,
    y2: 396.02,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BF6D28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#FBF2C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#DBA05F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#CD7C3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#F7C189"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#D5803B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FBF2C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#F7C189"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#BF6D28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#DBA05F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#CD7C3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBF2C4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_2109_83633",
    x1: 734.086,
    y1: 0.0000330958,
    x2: 916.53,
    y2: 0.0000330958,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BF6D28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#FBF2C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#DBA05F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#CD7C3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#F7C189"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#D5803B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FBF2C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#F7C189"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#BF6D28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#DBA05F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#CD7C3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBF2C4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_2109_83633",
    x1: 734.4,
    y1: 396.02,
    x2: 916.217,
    y2: 396.02,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BF6D28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#FBF2C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#DBA05F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#CD7C3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#F7C189"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#D5803B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FBF2C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#F7C189"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#BF6D28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#DBA05F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#CD7C3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBF2C4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_2109_83633",
    x1: 734.713,
    y1: 396.02,
    x2: 915.903,
    y2: 396.02,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BF6D28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#FBF2C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#DBA05F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#CD7C3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#F7C189"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#D5803B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FBF2C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#F7C189"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#BF6D28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#DBA05F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#CD7C3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBF2C4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_2109_83633",
    x1: 735.026,
    y1: 396.02,
    x2: 915.59,
    y2: 396.02,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BF6D28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#FBF2C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#DBA05F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#CD7C3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#F7C189"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#D5803B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FBF2C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#F7C189"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#BF6D28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#DBA05F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#CD7C3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBF2C4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_2109_83633",
    x1: 735.34,
    y1: 396.02,
    x2: 915.277,
    y2: 396.02,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BF6D28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#FBF2C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#DBA05F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#CD7C3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#F7C189"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#D5803B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FBF2C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#F7C189"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#BF6D28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#DBA05F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#CD7C3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBF2C4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_2109_83633",
    x1: 735.653,
    y1: 0.0000716768,
    x2: 914.963,
    y2: 0.0000716768,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BF6D28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#FBF2C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#DBA05F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#CD7C3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#F7C189"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#D5803B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FBF2C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#F7C189"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#BF6D28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#DBA05F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#CD7C3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBF2C4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_2109_83633",
    x1: 735.967,
    y1: 396.02,
    x2: 914.65,
    y2: 396.02,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BF6D28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#FBF2C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#DBA05F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#CD7C3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#F7C189"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#D5803B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FBF2C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#F7C189"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#BF6D28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#DBA05F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#CD7C3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBF2C4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_2109_83633",
    x1: 736.265,
    y1: 396.02,
    x2: 914.337,
    y2: 396.02,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BF6D28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#FBF2C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#DBA05F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#CD7C3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#F7C189"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#D5803B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FBF2C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#F7C189"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#BF6D28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#DBA05F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#CD7C3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBF2C4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_2109_83633",
    x1: 736.578,
    y1: 0.0000709077,
    x2: 914.023,
    y2: 0.0000709077,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BF6D28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#FBF2C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#DBA05F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#CD7C3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#F7C189"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#D5803B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FBF2C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#F7C189"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#BF6D28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#DBA05F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#CD7C3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBF2C4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_2109_83633",
    x1: 736.892,
    y1: 396.02,
    x2: 913.71,
    y2: 396.02,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BF6D28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#FBF2C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#DBA05F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#CD7C3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#F7C189"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#D5803B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FBF2C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#F7C189"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#BF6D28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#DBA05F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#CD7C3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBF2C4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_2109_83633",
    x1: 737.205,
    y1: 0.0000528115,
    x2: 913.412,
    y2: 0.0000528115,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BF6D28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#FBF2C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#DBA05F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#CD7C3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#F7C189"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#D5803B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FBF2C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#F7C189"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#BF6D28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#DBA05F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#CD7C3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBF2C4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_2109_83633",
    x1: 737.518,
    y1: 396.02,
    x2: 913.098,
    y2: 396.02,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BF6D28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#FBF2C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#DBA05F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#CD7C3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#F7C189"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#D5803B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FBF2C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#F7C189"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#BF6D28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#DBA05F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#CD7C3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBF2C4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_2109_83633",
    x1: 737.832,
    y1: 396.02,
    x2: 912.785,
    y2: 396.02,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BF6D28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#FBF2C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#DBA05F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#CD7C3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#F7C189"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#D5803B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FBF2C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#F7C189"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#BF6D28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#DBA05F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#CD7C3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBF2C4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_2109_83633",
    x1: 738.145,
    y1: 396.02,
    x2: 912.471,
    y2: 396.02,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BF6D28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#FBF2C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#DBA05F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#CD7C3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#F7C189"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#D5803B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FBF2C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#F7C189"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#BF6D28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#DBA05F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#CD7C3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBF2C4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_2109_83633",
    x1: 825.309,
    y1: 309.293,
    x2: 825.309,
    y2: 482.746,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BF6D28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#FBF2C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#DBA05F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#CD7C3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#F7C189"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#D5803B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FBF2C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#F7C189"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#BF6D28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#DBA05F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#CD7C3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBF2C4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_2109_83633",
    x1: 222.776,
    y1: 316.593,
    x2: 130.574,
    y2: 476.386,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9A9CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#9688B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#8579B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#635F8E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#625D8E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#5C4F91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A4B93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_2109_83633",
    x1: 176.632,
    y1: 309.293,
    x2: 176.632,
    y2: 482.746,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB942E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#F3F4C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#D8C064"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#CCA33E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#F7DE8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#D3AA41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F3F4C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#F7DE8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#BB942E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#D8C064"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#CCA33E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F4C5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_2109_83633",
    x1: 627.145,
    y1: 324.868,
    x2: 374.626,
    y2: 762.545,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9A9CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#9688B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#8579B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#635F8E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#625D8E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#5C4F91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A4B93"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2109_83633"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1000,
    height: 550,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAward);
export default __webpack_public_path__ + "static/media/award.cdae3bceaec7efea8c28a5398eefa7a5.svg";
export { ForwardRef as ReactComponent };